export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  AspectRatio: { input: any; output: any };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  HTML: { input: any; output: any };
  Identifier: { input: any; output: any };
  JSON: { input: any; output: any };
  JSONObject: { input: any; output: any };
  LanguageCode: { input: any; output: any };
  Markdown: { input: any; output: any };
  NavigationLabelValue: { input: any; output: any };
  Slug: { input: any; output: any };
  URL: { input: any; output: any };
  Unist: { input: any; output: any };
};

/** A single call-to-action */
export type Action = {
  __typename?: "Action";
  label?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
};

/** Input for adding donation comments */
export type AddDonationCommentInput = {
  donationComment?: InputMaybe<DonationCommentInput>;
  feedbackComment?: InputMaybe<Scalars["String"]["input"]>;
  postGivingToken: Scalars["String"]["input"];
};

/** Information to initialize adding a payment method for a subscription */
export type AddSubscriptionPaymentMethod = {
  __typename?: "AddSubscriptionPaymentMethod";
  clientSecret: Scalars["String"]["output"];
  customerId: Scalars["String"]["output"];
  ephemeralKey: Scalars["String"]["output"];
  publishableKey: Scalars["String"]["output"];
};

/** Input for the `admin_user` query */
export type AdminUserInput = {
  guid: Scalars["ID"]["input"];
};

/** Details of a user in an authentication provider */
export type Admin_AuthenticationProviderUser = {
  __typename?: "Admin_AuthenticationProviderUser";
  created: Scalars["Date"]["output"];
  email?: Maybe<Scalars["String"]["output"]>;
  hasVerifiedEmail: Scalars["Boolean"]["output"];
  /** The user's ID in the authentication provider's system */
  id: Scalars["ID"]["output"];
  lastSeen?: Maybe<Scalars["Date"]["output"]>;
};

export type Admin_ClassUserData = {
  __typename?: "Admin_ClassUserData";
  id: Scalars["ID"]["output"];
  isComplete: Scalars["Boolean"]["output"];
};

/** Input for the `admin_deleteAuthProviderAccount` mutation */
export type Admin_DeleteAuthProviderAccountInput = {
  /** The id for the user account in the authentication provider */
  providerUserId: Scalars["String"]["input"];
};

/** A campaign of emails sent to users */
export type Admin_EmailCampaign = {
  __typename?: "Admin_EmailCampaign";
  id?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

/** A variation on an email campaign */
export type Admin_EmailCampaignVariation = {
  __typename?: "Admin_EmailCampaignVariation";
  id?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

/** The connection for a user's email campaigns, ordered by last activity time */
export type Admin_EmailInteractionConnection = {
  __typename?: "Admin_EmailInteractionConnection";
  dataLastUpdatedAt?: Maybe<Scalars["Date"]["output"]>;
  edges: Array<Admin_EmailInteractionEdge>;
  nodes: Array<Admin_UserEmailInteraction>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** An edge containing an individual email interaction */
export type Admin_EmailInteractionEdge = {
  __typename?: "Admin_EmailInteractionEdge";
  cursor: Scalars["String"]["output"];
  node: Admin_UserEmailInteraction;
};

export type Admin_ModuleUserData = {
  __typename?: "Admin_ModuleUserData";
  id: Scalars["ID"]["output"];
  isComplete: Scalars["Boolean"]["output"];
};

/** A user-subscribable newsletter */
export type Admin_Newsletter = {
  __typename?: "Admin_Newsletter";
  language?: Maybe<Scalars["LanguageCode"]["output"]>;
  type: NewsletterType;
};

/** A user's subscription preference for a newsletter */
export type Admin_NewsletterPreference = {
  __typename?: "Admin_NewsletterPreference";
  id: Scalars["ID"]["output"];
  newsletter: Admin_Newsletter;
  status: NewsletterPreferenceStatus;
};

export type Admin_SessionUserData = {
  __typename?: "Admin_SessionUserData";
  id: Scalars["ID"]["output"];
  isComplete: Scalars["Boolean"]["output"];
};

/** Input for the `admin_updateEmail` mutation */
export type Admin_UpdateEmailInput = {
  guid: Scalars["ID"]["input"];
  newEmail: Scalars["String"]["input"];
};

/** A BibleProject user being accessed by an administrator. */
export type Admin_User = {
  __typename?: "Admin_User";
  authenticationProviderUser?: Maybe<Admin_AuthenticationProviderUser>;
  /** Times a user has interacted with an email campaign */
  emailInteractions: Admin_EmailInteractionConnection;
  /** Get the status of a user's Newsletter subscriptions, optionally filtered by newsletter language */
  newsletterPreferences?: Maybe<Array<Admin_NewsletterPreference>>;
};

/** A BibleProject user being accessed by an administrator. */
export type Admin_UserEmailInteractionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A BibleProject user being accessed by an administrator. */
export type Admin_UserNewsletterPreferencesArgs = {
  language?: InputMaybe<Scalars["LanguageCode"]["input"]>;
};

/** A record of a user's interaction with an email campaign */
export type Admin_UserEmailInteraction = {
  __typename?: "Admin_UserEmailInteraction";
  campaign?: Maybe<Admin_EmailCampaign>;
  campaignVariation?: Maybe<Admin_EmailCampaignVariation>;
  id: Scalars["String"]["output"];
  interactionType: EmailInteractionType;
  timestamp: Scalars["Date"]["output"];
};

/** Activity information related to a specific piece of content for a user */
export type AggregateContentActivity = {
  __typename?: "AggregateContentActivity";
  contentId: Scalars["ID"]["output"];
  viewerProgress?: Maybe<AggregateContentUserProgress>;
};

/** An individual record of user content progress */
export type AggregateContentUserProgress = {
  __typename?: "AggregateContentUserProgress";
  completedAt?: Maybe<Scalars["Date"]["output"]>;
  /** Value between 0 and 100 */
  percentComplete: Scalars["Int"]["output"];
  /**
   * total progress value of all children, if a child is complete its considered 100% complete for
   * calculation purposes.
   */
  total: Scalars["Int"]["output"];
  updatedAt: Scalars["Date"]["output"];
};

/** The connection for alt languages to their related items */
export type AlternateLanguagesConnection = {
  __typename?: "AlternateLanguagesConnection";
  edges: Array<AlternateLanguagesEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** The edge that connects to a piece of core content via alt languages */
export type AlternateLanguagesEdge = {
  __typename?: "AlternateLanguagesEdge";
  cursor: Scalars["String"]["output"];
  node: RelatedItem;
};

/** A single BibleProject article. */
export type Article = CoreLanguageContent & {
  __typename?: "Article";
  activity: IndividualContentActivity;
  alternateLanguages: AlternateLanguagesConnection;
  author?: Maybe<Person>;
  color?: Maybe<Scalars["String"]["output"]>;
  content?: Maybe<Scalars["Unist"]["output"]>;
  createdAt: Scalars["String"]["output"];
  /** @deprecated Use excerpt for user-facing content, or meta.description for SEO. */
  description: Scalars["Markdown"]["output"];
  durationSeconds?: Maybe<Scalars["Int"]["output"]>;
  excerpt?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  images: ImageSet;
  label?: Maybe<Scalars["String"]["output"]>;
  language: ContentLanguage;
  meta: PageMeta;
  plainText?: Maybe<Scalars["String"]["output"]>;
  publishedAt?: Maybe<Scalars["String"]["output"]>;
  pullQuote?: Maybe<Scalars["String"]["output"]>;
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  resourceLinks?: Maybe<Array<Maybe<ResourceLink>>>;
  slug: Scalars["String"]["output"];
  subtitle?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
};

/** A single BibleProject article. */
export type ArticleAlternateLanguagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A page of articles with edges and pageInfo */
export type ArticlesConnection = {
  __typename?: "ArticlesConnection";
  edges: Array<ArticlesEdge>;
  pageInfo: PageInfo;
};

/** An edge with an Article node from a connection */
export type ArticlesEdge = {
  __typename?: "ArticlesEdge";
  cursor: Scalars["String"]["output"];
  node: Article;
};

export type Audio = MediaObject & {
  __typename?: "Audio";
  contentType: MediaContentType;
  /** @deprecated Field is no longer supported. Use session.duration instead. */
  duration: Scalars["Int"]["output"];
  externalId: Scalars["String"]["output"];
  type: MediaType;
  url: Scalars["URL"]["output"];
};

/** An audio trailer */
export type AudioTrailer = {
  __typename?: "AudioTrailer";
  durationSeconds?: Maybe<Scalars["Int"]["output"]>;
  mp3?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

/** An object containing information related to user authorization */
export type Authorization = {
  __typename?: "Authorization";
  /** A custom Firebase token, to be exchanged with the Firebase SDK's `signInWithCustomToken` function */
  customToken?: Maybe<Scalars["String"]["output"]>;
  refresh?: Maybe<AuthorizationRefresh>;
  /** A bearer token to be included in an "Authorization" header */
  token?: Maybe<Scalars["String"]["output"]>;
};

/** Information needed to refresh an authorization token */
export type AuthorizationRefresh = {
  __typename?: "AuthorizationRefresh";
  /** A one-time string that must be included the first time a refresh token is exchanged for a new authorization token */
  nonce?: Maybe<Scalars["String"]["output"]>;
  /** A long lived token that can be exchanged for a new short lived authorization token */
  token?: Maybe<Scalars["String"]["output"]>;
};

/** A BibleProject profile avatar */
export type Avatar = {
  __typename?: "Avatar";
  createdAt: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  image: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
};

/** Input to update a user's avatar */
export type AvatarInput = {
  id: Scalars["ID"]["input"];
  /** The url of the avatar image */
  image: Scalars["String"]["input"];
};

/** A Bank Account payment method */
export type BankAccountPaymentMethod = SubscriptionPaymentMethod & {
  __typename?: "BankAccountPaymentMethod";
  bankName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  last4: Scalars["String"]["output"];
};

/** A book of the Bible */
export type BibleBook = {
  __typename?: "BibleBook";
  absoluteOrder?: Maybe<Scalars["Int"]["output"]>;
  apiId: Scalars["String"]["output"];
  bibleChapters?: Maybe<BibleChaptersConnection>;
  exploreItem?: Maybe<ExploreItem>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  shortName: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
};

/** A book of the Bible */
export type BibleBookBibleChaptersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The available sort properties for BibleBooks */
export enum BibleBookSortField {
  ProtestantOrder = "PROTESTANT_ORDER",
}

/**
 * An instance of a bible book sort input, providing a field and direction.
 * Multiple can be provided, for multi dimensional sort.
 */
export type BibleBookSortInput = {
  direction: SortEnum;
  field: BibleBookSortField;
};

/** A paginated list of books of the Bible */
export type BibleBooksConnection = {
  __typename?: "BibleBooksConnection";
  edges: Array<BibleBooksEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A single Bible book in a paginated list */
export type BibleBooksEdge = {
  __typename?: "BibleBooksEdge";
  cursor: Scalars["String"]["output"];
  node: BibleBook;
};

/** A single chapter in the Bible */
export type BibleChapter = {
  __typename?: "BibleChapter";
  absoluteOrder?: Maybe<Scalars["Int"]["output"]>;
  bookId: Scalars["Int"]["output"];
  chapterAudio: Array<Maybe<BibleChapterAudio>>;
  chapterNumber: Scalars["Int"]["output"];
  hasRelatedItems?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  primaryVideoClip?: Maybe<VideoClip>;
  relatedItems?: Maybe<Array<Maybe<RelatedItem>>>;
};

/** An audio file containing audio related to a Bible chapter */
export type BibleChapterAudio = {
  __typename?: "BibleChapterAudio";
  audioFileUrl: Scalars["String"]["output"];
  chapterId: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  translationId: Scalars["Int"]["output"];
};

/** A paginated list of Bible chapters */
export type BibleChaptersConnection = {
  __typename?: "BibleChaptersConnection";
  edges: Array<BibleChaptersEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A single Bible chapter in a paginated list */
export type BibleChaptersEdge = {
  __typename?: "BibleChaptersEdge";
  cursor: Scalars["String"]["output"];
  node: BibleChapter;
};

/** A collection of books in the Bible */
export type BibleCollection = {
  __typename?: "BibleCollection";
  items?: Maybe<Array<Maybe<ExploreItem>>>;
  name: Scalars["String"]["output"];
};

/** Scripture content */
export type BibleContentResponse = {
  __typename?: "BibleContentResponse";
  bookApiId?: Maybe<Scalars["String"]["output"]>;
  bookId?: Maybe<Scalars["Int"]["output"]>;
  bookName?: Maybe<Scalars["String"]["output"]>;
  bookShortName?: Maybe<Scalars["String"]["output"]>;
  items?: Maybe<Array<Maybe<BibleItem>>>;
  query?: Maybe<Scalars["String"]["output"]>;
  translationId?: Maybe<Scalars["Int"]["output"]>;
  translationName?: Maybe<Scalars["String"]["output"]>;
};

/** A section of scripture content or structural information */
export type BibleItem = {
  __typename?: "BibleItem";
  chapterId: Scalars["Int"]["output"];
  chapterNumber: Scalars["Int"]["output"];
  content?: Maybe<Scalars["String"]["output"]>;
  links?: Maybe<Array<Maybe<StudyLink>>>;
  parentStyle?: Maybe<Scalars["String"]["output"]>;
  string: Scalars["String"]["output"];
  style?: Maybe<Scalars["String"]["output"]>;
  table?: Maybe<Array<Maybe<Array<Maybe<BibleItemTableCell>>>>>;
  type?: Maybe<Scalars["String"]["output"]>;
  verseId: Scalars["Int"]["output"];
  verseNumber: Scalars["Int"]["output"];
  verseNumberEnd: Scalars["Int"]["output"];
};

/** A single cell in a table of information within scripture */
export type BibleItemTableCell = {
  __typename?: "BibleItemTableCell";
  align?: Maybe<Scalars["String"]["output"]>;
  items?: Maybe<Array<Maybe<BibleItemTableCellItem>>>;
};

/** A secton of content within a Bible content table cell */
export type BibleItemTableCellItem = {
  __typename?: "BibleItemTableCellItem";
  content: Scalars["String"]["output"];
  links?: Maybe<Array<Maybe<StudyLink>>>;
  style?: Maybe<Scalars["String"]["output"]>;
};

/** An auditorial reading of the bible composed in segments */
export type BibleReading = {
  __typename?: "BibleReading";
  audio?: Maybe<Scalars["String"]["output"]>;
  colors?: Maybe<ColorSet>;
  durationSeconds?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  images: ImageSet;
  reference?: Maybe<Scalars["String"]["output"]>;
  reflections?: Maybe<Array<Maybe<ReflectionSet>>>;
  segments?: Maybe<Array<Maybe<Segment>>>;
  slug: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  titleImage?: Maybe<ImageSet>;
  translation: BibleTranslation;
};

/** Multiple chapters */
export type BibleText = {
  __typename?: "BibleText";
  bookName: Scalars["String"]["output"];
  chapters?: Maybe<Array<BibleTextChapter>>;
  messages?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  query: Scalars["String"]["output"];
  ranges: Array<VerseRange>;
  relationships: RelationshipConnection;
};

/** Multiple chapters */
export type BibleTextRelationshipsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  predicates?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** A chapter of the bible, in a specific translation */
export type BibleTextChapter = {
  __typename?: "BibleTextChapter";
  book: Scalars["String"]["output"];
  chapter: Scalars["Int"]["output"];
  stylesheets?: Maybe<Array<BibleTextStylesheet>>;
  text: Scalars["String"]["output"];
  translation: Scalars["String"]["output"];
  verses?: Maybe<Array<BibleTextVerse>>;
};

/** A divine name style */
export type BibleTextDivineName = {
  __typename?: "BibleTextDivineName";
  properties: BibleTextDivineNameProperties;
  range: Array<Scalars["Int"]["output"]>;
  type: Scalars["String"]["output"];
};

/** The properties of a divine name style */
export type BibleTextDivineNameProperties = {
  __typename?: "BibleTextDivineNameProperties";
  smallCaps: Scalars["Int"]["output"];
};

/** An intent style */
export type BibleTextIndent = {
  __typename?: "BibleTextIndent";
  properties: BibleTextIndentProperties;
  range: Array<Scalars["Int"]["output"]>;
  type: Scalars["String"]["output"];
};

/** The properties of an indent style */
export type BibleTextIndentProperties = {
  __typename?: "BibleTextIndentProperties";
  depth: Scalars["Int"]["output"];
};

/** A paragraph style */
export type BibleTextParagraph = {
  __typename?: "BibleTextParagraph";
  range: Array<Scalars["Int"]["output"]>;
  type: Scalars["String"]["output"];
};

/** A redLetter style */
export type BibleTextRedLetter = {
  __typename?: "BibleTextRedLetter";
  range: Array<Scalars["Int"]["output"]>;
  type: Scalars["String"]["output"];
};

/** A smallcaps style */
export type BibleTextSmallCaps = {
  __typename?: "BibleTextSmallCaps";
  range: Array<Scalars["Int"]["output"]>;
  type: Scalars["String"]["output"];
};

/** A style included in a stylesheet */
export type BibleTextStyle =
  | BibleTextDivineName
  | BibleTextIndent
  | BibleTextParagraph
  | BibleTextRedLetter
  | BibleTextSmallCaps;

/** A stylesheet to be used to annotate a bible chapter */
export type BibleTextStylesheet = {
  __typename?: "BibleTextStylesheet";
  label: Scalars["String"]["output"];
  styles?: Maybe<Array<BibleTextStyle>>;
};

/** A single verse's location in a chapter */
export type BibleTextVerse = {
  __typename?: "BibleTextVerse";
  location: Scalars["Int"]["output"];
  value: Scalars["Int"]["output"];
};

/** An individual translation of the Bible */
export type BibleTranslation = {
  __typename?: "BibleTranslation";
  /** @deprecated Use 'translationPhilosophy' instead */
  categoryName: Scalars["String"]["output"];
  copyright: Copyright;
  description: Scalars["Markdown"]["output"];
  fullName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  publisher: Scalars["String"]["output"];
  translationPhilosophy: Scalars["String"]["output"];
};

/** The available sort properties for Bible translations */
export enum BibleTranslationSortField {
  Name = "NAME",
}

/** An instance of a translation sort input, providing a field and direction. */
export type BibleTranslationSortInput = {
  direction: SortEnum;
  field: BibleTranslationSortField;
};

/** A paginated list of Bible translations */
export type BibleTranslationsConnection = {
  __typename?: "BibleTranslationsConnection";
  edges: Array<BibleTranslationsEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A single translation within a paginated list */
export type BibleTranslationsEdge = {
  __typename?: "BibleTranslationsEdge";
  cursor: Scalars["String"]["output"];
  node: BibleTranslation;
};

/** Metadata about a Bible verse */
export type BibleVerse = {
  __typename?: "BibleVerse";
  absoluteOrder?: Maybe<Scalars["Int"]["output"]>;
  chapterId: Scalars["Int"]["output"];
  chapterTitle?: Maybe<Scalars["String"]["output"]>;
  hasRelatedItems: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  imagesAfterVerse?: Maybe<Array<Maybe<BibleVerseImage>>>;
  imagesBeforeVerse?: Maybe<Array<Maybe<BibleVerseImage>>>;
  movementReadingUnit?: Maybe<MovementReadingUnit>;
  relatedItems?: Maybe<Array<Maybe<RelatedItem>>>;
  verseNumber: Scalars["Int"]["output"];
};

/** Information about an image associated with a Bible verse */
export type BibleVerseImage = {
  __typename?: "BibleVerseImage";
  alt?: Maybe<Scalars["String"]["output"]>;
  aspectRatio?: Maybe<Scalars["Float"]["output"]>;
  type: BibleVerseImageType;
  url: Scalars["String"]["output"];
};

/** The intended purpose for an image associated with a Bible verse */
export enum BibleVerseImageType {
  Narrative = "narrative",
  Unit = "unit",
}

/** A paginated list of Bible verse metadata */
export type BibleVersesConnection = {
  __typename?: "BibleVersesConnection";
  edges: Array<BibleVersesEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A single Bible verse in a paginated list */
export type BibleVersesEdge = {
  __typename?: "BibleVersesEdge";
  cursor: Scalars["String"]["output"];
  node: BibleVerse;
};

/** Billing Date Anchor */
export type BillingDateAnchor = {
  __typename?: "BillingDateAnchor";
  /** Day must be between 1-31 */
  day: Scalars["Int"]["output"];
  month?: Maybe<BillingDateAnchorMonth>;
};

/**
 * Billing Date Anchor Input
 * Used when a billing date anchor is required as input. For updating
 * a billing date anchor, see BillingDateAnchorUpdateInput.
 */
export type BillingDateAnchorInput = {
  /** Day must be between 1-31 */
  day: Scalars["Int"]["input"];
  month?: InputMaybe<BillingDateAnchorMonth>;
};

/** Billing Schedule Month */
export enum BillingDateAnchorMonth {
  April = "APRIL",
  August = "AUGUST",
  December = "DECEMBER",
  February = "FEBRUARY",
  January = "JANUARY",
  July = "JULY",
  June = "JUNE",
  March = "MARCH",
  May = "MAY",
  November = "NOVEMBER",
  October = "OCTOBER",
  September = "SEPTEMBER",
}

/**
 * Billing Date Anchor Update Input
 * An update to a subscription's billing date anchor. We do not support
 * updating the billing anchor for yearly subscriptions, so only monthly
 * billing date anchors are represented by this type.
 */
export type BillingDateAnchorUpdateInput = {
  /** Day must be between 1-31 */
  day: Scalars["Int"]["input"];
};

/** Billing Schedule Change Preview Input */
export type BillingScheduleChangePreviewInput = {
  currentBillingAnchor: BillingDateAnchorInput;
  currentFrequency: SubscriptionFrequency;
  currentNextBillingDate: Scalars["Date"]["input"];
  newBillingAnchor?: InputMaybe<BillingDateAnchorUpdateInput>;
  newFrequency: SubscriptionFrequency;
};

/** Response to a BillingScheduleChangePreview query */
export type BillingScheduleChangePreviewResponse = {
  __typename?: "BillingScheduleChangePreviewResponse";
  nextBillingDate: Scalars["Date"]["output"];
};

/** An article written by BibleProject */
export type BlogPost = Node &
  TimelineEventData & {
    __typename?: "BlogPost";
    author?: Maybe<Person>;
    content?: Maybe<Array<Maybe<BlogPostContent>>>;
    description: Scalars["Markdown"]["output"];
    durationSeconds?: Maybe<Scalars["Int"]["output"]>;
    excerpt?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    images: ImageSet;
    label?: Maybe<Scalars["String"]["output"]>;
    plainText?: Maybe<Scalars["String"]["output"]>;
    publishDate?: Maybe<Scalars["Date"]["output"]>;
    relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
    relatedItemType?: Maybe<Scalars["String"]["output"]>;
    resourceLinks?: Maybe<Array<Maybe<BlogPostResourceLink>>>;
    sequenceItemInfo?: Maybe<SequenceItemInfo>;
    slug: Scalars["String"]["output"];
    subtitle?: Maybe<Scalars["String"]["output"]>;
    timelineSeconds?: Maybe<Scalars["Int"]["output"]>;
    title: Scalars["String"]["output"];
    url?: Maybe<Scalars["String"]["output"]>;
  };

/** A section of article content */
export type BlogPostContent = {
  __typename?: "BlogPostContent";
  heading?: Maybe<Scalars["String"]["output"]>;
  image?: Maybe<ImageSet>;
  scripture?: Maybe<ScriptureObj>;
  text?: Maybe<Scalars["String"]["output"]>;
  type: BlogPostContentType;
  video?: Maybe<Video>;
};

/** The type of a section of article content */
export enum BlogPostContentType {
  Heading = "heading",
  Image = "image",
  Scripture = "scripture",
  Text = "text",
  Video = "video",
}

/** @deprecated A web link embedded in a blogPost */
export type BlogPostResourceLink = {
  __typename?: "BlogPostResourceLink";
  item?: Maybe<RelatedItem>;
  url: Scalars["String"]["output"];
};

/** The readership category of a book */
export enum BookCategory {
  Academic = "ACADEMIC",
  Popular = "POPULAR",
}

/** A reference to a book */
export type BookReference = Node &
  TimelineEventData & {
    __typename?: "BookReference";
    authors: Array<Person>;
    category: BookCategory;
    id: Scalars["ID"]["output"];
    label?: Maybe<Scalars["String"]["output"]>;
    relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
    relatedItemType?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use `authors` instead */
    subtitle?: Maybe<Scalars["String"]["output"]>;
    timelineSeconds?: Maybe<Scalars["Int"]["output"]>;
    title: Scalars["String"]["output"];
    topics: Array<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
  };

export type BookmarkInput = {
  contentId: Scalars["ID"]["input"];
  contentType: ContentType;
};

export type Bookmarkable = Class | Module | Session;

export enum CacheControlScope {
  Private = "PRIVATE",
  Public = "PUBLIC",
}

/** Information to cancel a subscription */
export type CancelSubscriptionInput = {
  subscriptionId: Scalars["ID"]["input"];
};

/** A Card payment method */
export type CardPaymentMethod = SubscriptionPaymentMethod & {
  __typename?: "CardPaymentMethod";
  brand: Scalars["String"]["output"];
  expMonth: Scalars["Int"]["output"];
  expYear: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  last4: Scalars["String"]["output"];
  walletType?: Maybe<Scalars["String"]["output"]>;
};

/** A CashApp payment method */
export type CashAppPaymentMethod = SubscriptionPaymentMethod & {
  __typename?: "CashAppPaymentMethod";
  cashTag: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

/** Categorization information about a Resource */
export type Category = {
  __typename?: "Category";
  id: Scalars["ID"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

/** Change active subscription payment method */
export type ChangeActiveSubscriptionPaymentMethodInput = {
  paymentMethodId: Scalars["String"]["input"];
};

/** A heading identifying a chapter in an audio file */
export type ChapterHeading = TimelineEventData & {
  __typename?: "ChapterHeading";
  caption?: Maybe<Scalars["String"]["output"]>;
  chapterNum?: Maybe<Scalars["Int"]["output"]>;
  question?: Maybe<Scalars["String"]["output"]>;
  relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  timelineSeconds?: Maybe<Scalars["Int"]["output"]>;
  title: Scalars["String"]["output"];
  /** Intro, Recap, or Standard */
  type?: Maybe<Scalars["String"]["output"]>;
};

/** A single chapter and verse pairing */
export type ChapterVerse = {
  __typename?: "ChapterVerse";
  chapter: Scalars["Int"]["output"];
  verse: Scalars["Int"]["output"];
};

/** A Classroom Class */
export type Class = ClassroomNode &
  Content & {
    __typename?: "Class";
    activity: AggregateContentActivity;
    admin_user?: Maybe<Admin_ClassUserData>;
    artwork: Array<ClassroomImage>;
    category: Scalars["String"]["output"];
    color: Palette;
    contentType: ContentType;
    /** @deprecated Field is no longer supported. Will be removed without replacement. */
    createdAt: Scalars["String"]["output"];
    description: Scalars["Markdown"]["output"];
    downloads?: Maybe<Array<ClassroomDownload>>;
    duration: Scalars["Int"]["output"];
    id: Scalars["ID"]["output"];
    language?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Field is no longer supported. Use id instead. */
    legacyId?: Maybe<Scalars["String"]["output"]>;
    media?: Maybe<ClassMediaConnection>;
    modules?: Maybe<ClassModuleConnection>;
    objectivesHtml?: Maybe<Scalars["HTML"]["output"]>;
    /** @deprecated Field is no longer supported. Will be removed without replacement. */
    prerequisites?: Maybe<Array<Class>>;
    publishedAt?: Maybe<Scalars["String"]["output"]>;
    quizCount: Scalars["Int"]["output"];
    relatedItemType?: Maybe<Scalars["String"]["output"]>;
    scripture: Scalars["String"]["output"];
    seo: Seo;
    sessionCount: Scalars["Int"]["output"];
    slug: Scalars["String"]["output"];
    /** @deprecated Field is no longer supported. Use tags instead - one class will have a NEWEST CLASS tag. */
    status?: Maybe<ContentStatus>;
    /** @deprecated Field is no longer supported. Will be removed without replacement. */
    studentCount: Scalars["Int"]["output"];
    /** @deprecated Field is no longer supported. Will be removed without replacement. */
    survey?: Maybe<ClassroomQuiz>;
    tags?: Maybe<Array<Tag>>;
    teacher?: Maybe<Teacher>;
    /** @deprecated Field is no longer supported. Use teacher.id instead. */
    teacherId?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Field is no longer supported. Will be removed without replacement. */
    testimonials?: Maybe<Array<Testimonial>>;
    title: Scalars["String"]["output"];
    updatedAt: Scalars["String"]["output"];
    user?: Maybe<ClassUserData>;
  };

/** A Classroom Class */
export type ClassAdmin_UserArgs = {
  guid: Scalars["String"]["input"];
};

/** A Classroom Class */
export type ClassArtworkArgs = {
  aspectRatio?: InputMaybe<Scalars["AspectRatio"]["input"]>;
};

/** A Classroom Class */
export type ClassMediaArgs = {
  mediaType?: InputMaybe<MediaType>;
};

export type ClassCategory = {
  __typename?: "ClassCategory";
  classes: Array<Class>;
  slug: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  updatedAt: Scalars["String"]["output"];
};

export type ClassMediaConnection = {
  __typename?: "ClassMediaConnection";
  edges?: Maybe<Array<ClassMediaEdge>>;
  nodes?: Maybe<Array<Media>>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ClassMediaEdge = {
  __typename?: "ClassMediaEdge";
  cursor: Scalars["String"]["output"];
  node?: Maybe<Media>;
};

export type ClassModuleConnection = {
  __typename?: "ClassModuleConnection";
  edges: Array<ClassModuleEdge>;
  nodes?: Maybe<Array<Module>>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ClassModuleEdge = {
  __typename?: "ClassModuleEdge";
  cursor: Scalars["String"]["output"];
  node?: Maybe<Module>;
};

export type ClassUserData = ContentUserData & {
  __typename?: "ClassUserData";
  /** @deprecated Field is no longer supported. Use Class.slug instead. */
  classSlug: Scalars["String"]["output"];
  completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  completionCertificate?: Maybe<CompletionCertificate>;
  currentSession?: Maybe<Session>;
  id: Scalars["ID"]["output"];
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  isBookmarked: Scalars["Boolean"]["output"];
  isComplete: Scalars["Boolean"]["output"];
  isFeedbackComplete: Scalars["Boolean"]["output"];
  progress?: Maybe<Scalars["Float"]["output"]>;
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  remainingDuration?: Maybe<Scalars["Int"]["output"]>;
};

/** A named group of related items */
export type ClassicRelatedItemGroup = {
  __typename?: "ClassicRelatedItemGroup";
  items?: Maybe<Array<Maybe<RelatedItem>>>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ClassroomDownload = {
  __typename?: "ClassroomDownload";
  mimeType: Scalars["String"]["output"];
  type: ClassroomDownloadType;
  url: Scalars["URL"]["output"];
};

export enum ClassroomDownloadType {
  FacilitatorGuide = "FACILITATOR_GUIDE",
  LiteralLiteraryTranslation = "LITERAL_LITERARY_TRANSLATION",
  TeacherNotes = "TEACHER_NOTES",
}

export type ClassroomImage = {
  __typename?: "ClassroomImage";
  altText?: Maybe<Scalars["String"]["output"]>;
  aspectRatio?: Maybe<Scalars["AspectRatio"]["output"]>;
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  previewUrl: Scalars["URL"]["output"];
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  title?: Maybe<Scalars["String"]["output"]>;
  url: Scalars["URL"]["output"];
};

export type ClassroomNode = {
  id?: Maybe<Scalars["ID"]["output"]>;
};

export type ClassroomQuiz = ClassroomNode & {
  __typename?: "ClassroomQuiz";
  /** @deprecated Field is no longer supported. Use ClassroomQuiz.module.class.slug instead. */
  classSlug: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /** @deprecated Field is no longer supported. Use id instead */
  legacyId?: Maybe<Scalars["String"]["output"]>;
  module?: Maybe<Module>;
  position: Scalars["Int"]["output"];
  questions: Array<ClassroomQuizQuestion>;
  title: Scalars["String"]["output"];
  /** @deprecated Field is no longer supported. Use questions instead. */
  unstable_questions?: Maybe<Scalars["JSON"]["output"]>;
  user?: Maybe<QuizUserData>;
};

export type ClassroomQuizQuestion =
  | FillInTheBlankQuestion
  | MatchingQuestion
  | MultipleChoiceQuestion
  | OrderingQuestion
  | SingleChoiceQuestion
  | TrueFalseQuestion;

export type ClassroomVideo = MediaObject & {
  __typename?: "ClassroomVideo";
  contentType: MediaContentType;
  /** @deprecated Field is no longer supported. Use session.duration instead */
  duration: Scalars["Int"]["output"];
  externalId: Scalars["String"]["output"];
  type: MediaType;
  url: Scalars["URL"]["output"];
};

/** Enum of the different type of bible collections */
export enum CollectionTag {
  NewTestament = "newTestament",
  OldTestament = "oldTestament",
}

/** A set of colors to be used in the BibleReading */
export type ColorSet = {
  __typename?: "ColorSet";
  primary?: Maybe<Scalars["String"]["output"]>;
  quaternary?: Maybe<Scalars["String"]["output"]>;
  secondary?: Maybe<Scalars["String"]["output"]>;
  tertiary?: Maybe<Scalars["String"]["output"]>;
};

export type CompletionCertificate = {
  __typename?: "CompletionCertificate";
  downloadUrl: Scalars["URL"]["output"];
  previewImageUrl: ClassroomImage;
};

export type Content = {
  contentType: ContentType;
  createdAt: Scalars["String"]["output"];
  description?: Maybe<Scalars["Markdown"]["output"]>;
  duration: Scalars["Int"]["output"];
  seo: Seo;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
  user?: Maybe<ContentUserData>;
};

/** A curated collection of BP content */
export type ContentBundle = {
  __typename?: "ContentBundle";
  createdAt: Scalars["String"]["output"];
  groups: Array<RelatedItemGroup>;
  id: Scalars["ID"]["output"];
  images: ImageSet;
  meta: PageMeta;
  params: Scalars["JSONObject"]["output"];
  publishedAt: Scalars["String"]["output"];
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  relatedItems: Array<RelatedItem>;
  slug: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
};

/** A language, but specific to the needs of content service. */
export type ContentLanguage = {
  __typename?: "ContentLanguage";
  code: Scalars["LanguageCode"]["output"];
  createdAt: Scalars["String"]["output"];
  /** The name of the language as spoken by its native speakers (e.g., "Español" for Spanish) */
  endonym: Scalars["String"]["output"];
  exonyms: Array<ContentLanguageExonym>;
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
};

/** A language, but specific to the needs of content service. */
export type ContentLanguageExonymsArgs = {
  codes?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** An exonym represents the name of a language as expressed by speakers of another language. */
export type ContentLanguageExonym = {
  __typename?: "ContentLanguageExonym";
  /** The language in which this exonym is expressed */
  language: ContentLanguage;
  /** The name of the language in the expressing language */
  name: Scalars["String"]["output"];
};

export enum ContentProgressContentType {
  Article = "ARTICLE",
  ClassroomSession = "CLASSROOM_SESSION",
  Guide = "GUIDE",
  PodcastEpisode = "PODCAST_EPISODE",
  Video = "VIDEO",
}

export type ContentProgressMetadataInput = {
  platform: ContentProgressPlatform;
};

export enum ContentProgressPlatform {
  App = "APP",
  Web = "WEB",
}

export enum ContentStatus {
  New = "NEW",
}

export enum ContentType {
  Class = "CLASS",
  Module = "MODULE",
  Session = "SESSION",
}

export type ContentUserData = {
  completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  isBookmarked: Scalars["Boolean"]["output"];
  isComplete: Scalars["Boolean"]["output"];
  progress?: Maybe<Scalars["Float"]["output"]>;
  remainingDuration?: Maybe<Scalars["Int"]["output"]>;
};

/** Copyright information */
export type Copyright = {
  __typename?: "Copyright";
  citation?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  link?: Maybe<Scalars["String"]["output"]>;
  logo?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Used by all content which actively cares about language
 * and the relationships between languages
 */
export type CoreLanguageContent = {
  alternateLanguages: AlternateLanguagesConnection;
  language: ContentLanguage;
};

/**
 * Used by all content which actively cares about language
 * and the relationships between languages
 */
export type CoreLanguageContentAlternateLanguagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Link to a classroom course */
export type Course = Node &
  TimelineEventData & {
    __typename?: "Course";
    id: Scalars["ID"]["output"];
    label?: Maybe<Scalars["String"]["output"]>;
    relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
    relatedItemType?: Maybe<Scalars["String"]["output"]>;
    timelineSeconds?: Maybe<Scalars["Int"]["output"]>;
    title: Scalars["String"]["output"];
    type?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
  };

/** Supported ISO 4217 currency codes */
export enum CurrencyCode {
  Usd = "USD",
}

/** Date range input */
export type DateRangeInput = {
  end?: InputMaybe<Scalars["Date"]["input"]>;
  start?: InputMaybe<Scalars["Date"]["input"]>;
};

/** A default giving amount */
export type DefaultGivingAmount = {
  __typename?: "DefaultGivingAmount";
  amount: Scalars["Int"]["output"];
  currency: Scalars["String"]["output"];
};

/** Delete a subscription payment method */
export type DeleteSubscriptionPaymentMethodInput = {
  paymentMethodId: Scalars["String"]["input"];
};

export type DiagramVisualData = VisualDataCommon & {
  __typename?: "DiagramVisualData";
  alt?: Maybe<Scalars["String"]["output"]>;
  caption?: Maybe<Scalars["HTML"]["output"]>;
  src: Scalars["URL"]["output"];
  title: Scalars["String"]["output"];
  type: VisualType;
};

/** A single entry in a list of items */
export type DigestItem = {
  __typename?: "DigestItem";
  label?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** An individual donation */
export type Donation = {
  __typename?: "Donation";
  /** The donation amount in the smallest currency unit of the currency (e.g., cents for USD). */
  amount: Scalars["Int"]["output"];
  closeDate: Scalars["Date"]["output"];
  comment?: Maybe<DonationComment>;
  currency: CurrencyCode;
  feedbackComment?: Maybe<Scalars["String"]["output"]>;
  frequency: DonationFrequency;
  id: Scalars["ID"]["output"];
  last4?: Maybe<Scalars["String"]["output"]>;
  paymentMethod: PaymentMethod;
  paymentTransactionStatus?: Maybe<PaymentTransactionStatus>;
  type: DonationType;
};

/** Donation comment details */
export type DonationComment = {
  __typename?: "DonationComment";
  comment: Scalars["String"]["output"];
  isPrivate: Scalars["Boolean"]["output"];
};

/** Input for adding a donation comment */
export type DonationCommentInput = {
  comment: Scalars["String"]["input"];
  keepPrivate: Scalars["Boolean"]["input"];
};

/** A connection to a list of `Donation` values. */
export type DonationConnection = {
  __typename?: "DonationConnection";
  edges: Array<DonationEdge>;
  pageInfo: PageInfo;
};

/** An edge containing a `Donation` and its cursor. */
export type DonationEdge = {
  __typename?: "DonationEdge";
  cursor: Scalars["String"]["output"];
  node: Donation;
};

/**
 * The frequency at which the Donation is given - oneTime if it's a one-off donation, and
 * monthly or annual if the Donation was made through a recurring subscription.
 */
export enum DonationFrequency {
  Annual = "annual",
  Monthly = "monthly",
  OneTime = "oneTime",
}

/** Filters for donation history */
export type DonationHistoryFilters = {
  /** The date range to filter donations by, start and end are inclusive. */
  closeDateRange?: InputMaybe<DateRangeInput>;
  type?: InputMaybe<Array<DonationType>>;
};

/** Sort field and direction for donation history */
export type DonationHistorySort = {
  direction: SortEnum;
  field: DonationHistorySortField;
};

/** Sort field for donation history */
export enum DonationHistorySortField {
  Amount = "Amount",
  CloseDate = "CloseDate",
  PaymentMethod = "PaymentMethod",
}

/** Company details for matching donations */
export type DonationMatchCompany = {
  __typename?: "DonationMatchCompany";
  id: Scalars["Int"]["output"];
  matchingGiftOffered: Scalars["Boolean"]["output"];
  matchingGiftRatio?: Maybe<Scalars["String"]["output"]>;
  maximumMatchAmount?: Maybe<Scalars["Int"]["output"]>;
  minimumMatchAmount?: Maybe<Scalars["Int"]["output"]>;
  name: Scalars["String"]["output"];
};

/** Input for searching for a company to match donations */
export type DonationMatchCompanyInput = {
  companyNamePrefix: Scalars["String"]["input"];
};

/** Company details for matching donations */
export type DonationMatchCompanyResult = {
  __typename?: "DonationMatchCompanyResult";
  companies: Array<DonationMatchCompany>;
};

/** Information about a subscription */
export type DonationSubscription = {
  __typename?: "DonationSubscription";
  amount: Scalars["Int"]["output"];
  billingAnchor: BillingDateAnchor;
  currency: CurrencyCode;
  frequency: SubscriptionFrequency;
  id: Scalars["ID"]["output"];
  nextPaymentDate: Scalars["Date"]["output"];
  paymentMethod?: Maybe<SubscriptionPaymentMethod>;
  paymentMethodId?: Maybe<Scalars["ID"]["output"]>;
  status: SubscriptionStatus;
};

/** type of donation */
export enum DonationType {
  Deductible = "Deductible",
  NonDeductible = "NonDeductible",
  Qualified = "Qualified",
}

/** Selection of perks that a user has earned */
export type EligibleMilestone = {
  __typename?: "EligibleMilestone";
  id: Scalars["ID"]["output"];
  /** Default selection will appear first in the list */
  selections: Array<EligibleMilestoneProductOption>;
};

/** Selection of a perk that a user has earned */
export type EligibleMilestoneProductOption = {
  __typename?: "EligibleMilestoneProductOption";
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  image: Scalars["String"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
};

/** Type of email interaction */
export enum EmailInteractionType {
  Clicked = "Clicked",
  Opened = "Opened",
}

/**
 * A Essay is an intentionally crafted unit of shippable,
 * written content which has been created by groups in
 * near orbit to Scholarship and have undergone editing
 * by the editing scholars.
 */
export type Essay = {
  content: Scalars["Unist"]["output"];
  createdAt: Scalars["String"]["output"];
  description: Scalars["Markdown"]["output"];
  id: Scalars["ID"]["output"];
  images: ImageSet;
  meta: PageMeta;
  /** only given a value when the data object originated in October */
  octoberId?: Maybe<Scalars["Int"]["output"]>;
  publishedAt: Scalars["String"]["output"];
  relatedItems: Array<RelatedItem>;
  resourceLinks: Array<ResourceLink>;
  slug: Scalars["String"]["output"];
  subTitle?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
};

/**
 * An Experimental Config from the content repo.
 *
 * In this type, date-based overrides have already been applied.
 */
export type ExperimentalConfig = {
  __typename?: "ExperimentalConfig";
  /** Config object as a JSON string */
  config: Scalars["JSONObject"]["output"];
  /** UUID of the config */
  id: Scalars["ID"]["output"];
  /** Config namespace, e.g. `app-promo-card` */
  namespace: Scalars["String"]["output"];
  /** Config version, e.g. `1` */
  version: Scalars["Int"]["output"];
};

/** A single Guide */
export type Experimental_Guide = {
  __typename?: "Experimental_Guide";
  activity: IndividualContentActivity;
  alternateLanguages: AlternateLanguagesConnection;
  category?: Maybe<GuideCategory>;
  content?: Maybe<Scalars["Unist"]["output"]>;
  createdAt: Scalars["String"]["output"];
  description: Scalars["Markdown"]["output"];
  digest?: Maybe<Array<DigestItem>>;
  diveDeeper: Array<Essay>;
  id: Scalars["ID"]["output"];
  images: ImageSet;
  /** @deprecated Use language instead. */
  lang: Scalars["String"]["output"];
  language: ContentLanguage;
  meta: PageMeta;
  name: Scalars["String"]["output"];
  octoberId?: Maybe<Scalars["Int"]["output"]>;
  publishedAt: Scalars["String"]["output"];
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  relatedItems?: Maybe<Array<Maybe<RelatedItem>>>;
  resourceLinks?: Maybe<Array<Maybe<ResourceLink>>>;
  sectionItems?: Maybe<Array<SectionRelatedItems>>;
  slug: Scalars["String"]["output"];
  /** @deprecated This field is no longer used. No alternative is provided. */
  subTitle?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
};

/** A single Guide */
export type Experimental_GuideAlternateLanguagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A help center page */
export type Experimental_HelpCenterPage = {
  __typename?: "Experimental_HelpCenterPage";
  description: Scalars["Markdown"]["output"];
  title: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

/** A static page of the website */
export type Experimental_StaticPage = {
  __typename?: "Experimental_StaticPage";
  description: Scalars["Markdown"]["output"];
  title: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

/** A group of related content items to be related to other items as a set */
export type ExploreItem = {
  __typename?: "ExploreItem";
  description: Scalars["Markdown"]["output"];
  genres: Array<Maybe<Scalars["String"]["output"]>>;
  id: Scalars["ID"]["output"];
  images: ImageSet;
  milestones?: Maybe<Array<Maybe<MileStone>>>;
  numVideos?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use relatedItems. */
  relatedItemGroups?: Maybe<RelatedItemGroupsNamed>;
  relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  relatedItems?: Maybe<Array<Maybe<RelatedItem>>>;
  scriptureReferences?: Maybe<Array<Maybe<ScriptureReference>>>;
  shareUrl?: Maybe<Scalars["String"]["output"]>;
  subtitle?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  videos: Array<Video>;
};

export type FeedbackInput = {
  classId: Scalars["ID"]["input"];
};

export type FillInTheBlankQuestion = ClassroomNode &
  QuizQuestionCommon & {
    __typename?: "FillInTheBlankQuestion";
    answer: Array<Scalars["String"]["output"]>;
    description: Scalars["String"]["output"];
    errorMessage: QuizQuestionFeedbackMessage;
    id: Scalars["ID"]["output"];
    /** @deprecated Field is no longer supported. Use id instead. */
    legacyId?: Maybe<Scalars["String"]["output"]>;
    options?: Maybe<Array<QuizQuestionOption>>;
    successMessage: QuizQuestionFeedbackMessage;
    template: Scalars["String"]["output"];
    title: Scalars["String"]["output"];
    type: QuizQuestionType;
    user?: Maybe<QuizQuestionUserData>;
  };

/** A request for giving at a particular frequency */
export type GivingAsk = {
  __typename?: "GivingAsk";
  /** Accent color of the giving ask */
  color: Scalars["String"]["output"];
  invitations: Array<Maybe<GivingAskInvite>>;
  /** A descriptive title for the giving ask */
  title: Scalars["String"]["output"];
  /** A type denoting the frequency of a gift being asked for */
  type: GivingAskType;
};

/** A recommended giving amount */
export type GivingAskInvite = {
  __typename?: "GivingAskInvite";
  /** The minimum amount in the smallest currency unit that the user is invited to give */
  amount: Scalars["Int"]["output"];
  /** The currency code for the amount */
  currency: Scalars["String"]["output"];
  /** A plain text description of the ask */
  description: Scalars["Markdown"]["output"];
  /** A markdown description of the ask */
  descriptionMarkdown?: Maybe<Scalars["String"]["output"]>;
};

/** The frequency of gift being requested */
export enum GivingAskType {
  Annual = "ANNUAL",
  Monthly = "MONTHLY",
  OneTime = "ONE_TIME",
}

/** Information about an invitation to give */
export type GivingCampaign = {
  __typename?: "GivingCampaign";
  /**
   * @deprecated This solution presently perpetuates a way of informing the relationship
   * between items in a way that is generated by hard-coded relations for
   * feature-parity. As we decide how connections and relationships work
   * moving forward, this field will be dropped.
   */
  _videos?: Maybe<GivingCampaignVideosConnection>;
  asks: Array<Maybe<GivingAsk>>;
  /** A plain-text, human readable, primary identifier of a given campaign */
  campaignCode: Scalars["String"]["output"];
};

/** Information about an invitation to give */
export type GivingCampaign_VideosArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** An identifier for a giving campaign */
export enum GivingCampaignCode {
  App = "app",
  Classroom = "classroom",
  Web = "web",
}

/** A paginated list of videos associated with a campaign */
export type GivingCampaignVideosConnection = {
  __typename?: "GivingCampaignVideosConnection";
  edges: Array<VideoEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A list of giving configurations */
export type GivingConfigurations = {
  __typename?: "GivingConfigurations";
  configurations: Array<GivingSourceConfiguration>;
};

/** A giving frequency configuration */
export type GivingFrequencyConfiguration = {
  __typename?: "GivingFrequencyConfiguration";
  defaultGivingAmounts: Array<DefaultGivingAmount>;
  frequency: DonationFrequency;
  title: Scalars["String"]["output"];
};

/** A single giving configuration for a giving source */
export type GivingSourceConfiguration = {
  __typename?: "GivingSourceConfiguration";
  frequencyConfigurations: Array<GivingFrequencyConfiguration>;
  source: GivingCampaignCode;
  video: Video;
};

/** Metadata about the supergraph and its services */
export type GlobalSystemInfo = {
  __typename?: "GlobalSystemInfo";
  /** Contains service metadata for auth service */
  auth: ServiceMetadata;
  /** Contains service metadata for classroom service */
  classroom: ServiceMetadata;
  /** Contains service metadata for content service */
  content: ServiceMetadata;
  /** Contains service metadata for payment service */
  payment: ServiceMetadata;
  /** Contains service metadata for profile service */
  profile: ServiceMetadata;
  /** Contains service metadata for userActivity service */
  userActivity: ServiceMetadata;
};

/** A single GuideCategory */
export type GuideCategory = {
  __typename?: "GuideCategory";
  alternateLanguages: AlternateLanguagesConnection;
  createdAt?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  guides: Array<Experimental_Guide>;
  id: Scalars["ID"]["output"];
  images?: Maybe<ImageSet>;
  /** @deprecated Use language instead. */
  lang: Scalars["String"]["output"];
  language: ContentLanguage;
  meta: PageMeta;
  octoberId?: Maybe<Scalars["Int"]["output"]>;
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["String"]["output"]>;
};

/** A single GuideCategory */
export type GuideCategoryAlternateLanguagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IllustrationVisualData = VisualDataCommon & {
  __typename?: "IllustrationVisualData";
  alt?: Maybe<Scalars["String"]["output"]>;
  caption?: Maybe<Scalars["HTML"]["output"]>;
  src: Scalars["URL"]["output"];
  title: Scalars["String"]["output"];
  type: VisualType;
};

/** The url for an image */
export type Image = TimelineEventData & {
  __typename?: "Image";
  label?: Maybe<Scalars["String"]["output"]>;
  relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  timelineSeconds?: Maybe<Scalars["Int"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
};

/** A single image in various sizes */
export type ImageSet = {
  __typename?: "ImageSet";
  aspect1x1?: Maybe<Scalars["String"]["output"]>;
  aspect9x16?: Maybe<Scalars["String"]["output"]>;
  aspect16x9?: Maybe<Scalars["String"]["output"]>;
  large?: Maybe<Scalars["String"]["output"]>;
  medium?: Maybe<Scalars["String"]["output"]>;
  mini?: Maybe<Scalars["String"]["output"]>;
  small?: Maybe<Scalars["String"]["output"]>;
};

export type ImageVisualData = VisualDataCommon & {
  __typename?: "ImageVisualData";
  alt?: Maybe<Scalars["String"]["output"]>;
  caption?: Maybe<Scalars["HTML"]["output"]>;
  src: Scalars["URL"]["output"];
  title: Scalars["String"]["output"];
  type: VisualType;
};

/** Activity information related to a specific piece of content for a user */
export type IndividualContentActivity = {
  __typename?: "IndividualContentActivity";
  contentId: Scalars["ID"]["output"];
  viewerProgress?: Maybe<IndividualContentUserProgress>;
};

/** An individual record of user content progress */
export type IndividualContentUserProgress = {
  __typename?: "IndividualContentUserProgress";
  completedAt?: Maybe<Scalars["Date"]["output"]>;
  /** Value between 0 and 100 */
  percentComplete: Scalars["Int"]["output"];
  updatedAt: Scalars["Date"]["output"];
  value: Scalars["Int"]["output"];
};

/** Instructional content */
export type Insight = TimelineEventData & {
  __typename?: "Insight";
  description: Scalars["Markdown"]["output"];
  /** URL of an image */
  icon?: Maybe<Scalars["String"]["output"]>;
  relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  timelineSeconds?: Maybe<Scalars["Int"]["output"]>;
  title: Scalars["String"]["output"];
  /** OFF, Tim Says:, Jon Says:, or generic */
  type?: Maybe<Scalars["String"]["output"]>;
};

/** An ordered group of studies covering scripture in sequence */
export type JourneyConnection = {
  __typename?: "JourneyConnection";
  edges: Array<JourneyEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A single study group within the journey */
export type JourneyEdge = {
  __typename?: "JourneyEdge";
  cursor: Scalars["String"]["output"];
  node: StudyGroup;
};

export type LiteraryDesign = VisualDataCommon & {
  __typename?: "LiteraryDesign";
  caption?: Maybe<Scalars["HTML"]["output"]>;
  html?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  reference?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  type: VisualType;
  usx?: Maybe<Scalars["String"]["output"]>;
};

/** A single locale */
export type Locale = {
  __typename?: "Locale";
  countries: Array<LocaleInformation>;
  createdAt?: Maybe<Scalars["String"]["output"]>;
  currency?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isRtl?: Maybe<Scalars["Boolean"]["output"]>;
  iso6391?: Maybe<Scalars["String"]["output"]>;
  iso6392?: Maybe<Scalars["String"]["output"]>;
  label: Scalars["String"]["output"];
  localizedNames: Array<LocaleInformation>;
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["String"]["output"]>;
};

/** Information about a locale or language */
export type LocaleInformation = {
  __typename?: "LocaleInformation";
  code: Scalars["String"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

/** Input for the `login` mutation */
export type LoginInput = {
  /** A nonce passed when the apple token was issued */
  appleNonce?: InputMaybe<Scalars["String"]["input"]>;
  /** An ID token issued by Apple login */
  appleToken?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  /** An ID token issued by a trusted Google auth client */
  googleToken?: InputMaybe<Scalars["String"]["input"]>;
  password?: InputMaybe<Scalars["String"]["input"]>;
};

/** Response for the `login` mutation */
export type LoginResponse = {
  __typename?: "LoginResponse";
  authorization?: Maybe<Authorization>;
};

export type MacroLiteraryDesign = VisualDataCommon & {
  __typename?: "MacroLiteraryDesign";
  caption: Scalars["HTML"]["output"];
  config?: Maybe<Scalars["JSON"]["output"]>;
  id: Scalars["ID"]["output"];
  reference: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  type: VisualType;
};

export type MatchingQuestion = ClassroomNode &
  QuizQuestionCommon & {
    __typename?: "MatchingQuestion";
    answer: Array<Scalars["String"]["output"]>;
    description: Scalars["String"]["output"];
    errorMessage: QuizQuestionFeedbackMessage;
    id: Scalars["ID"]["output"];
    items?: Maybe<Array<QuizQuestionItem>>;
    /** @deprecated Field is no longer supported. Use id instead. */
    legacyId?: Maybe<Scalars["String"]["output"]>;
    options?: Maybe<Array<QuizQuestionOption>>;
    successMessage: QuizQuestionFeedbackMessage;
    title: Scalars["String"]["output"];
    type: QuizQuestionType;
    user?: Maybe<QuizQuestionUserData>;
  };

export type Media = Audio | ClassroomVideo;

export enum MediaContentType {
  Audio = "AUDIO",
  Video = "VIDEO",
}

export type MediaObject = {
  contentType: MediaContentType;
  type: MediaType;
};

export enum MediaType {
  CompletionVideo = "COMPLETION_VIDEO",
  Postroll = "POSTROLL",
  Preroll = "PREROLL",
  SessionAudio = "SESSION_AUDIO",
  SessionVideo = "SESSION_VIDEO",
  Trailer = "TRAILER",
  Unknown = "UNKNOWN",
}

/** Important concepts covered by the group of items */
export type MileStone = {
  __typename?: "MileStone";
  description?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

/** Input for selecting a perk */
export type MilestoneSelectionInput = {
  milestoneId: Scalars["ID"]["input"];
  /** The ID of the option or null if the user declines the perk */
  productOptionId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type Module = ClassroomNode &
  Content & {
    __typename?: "Module";
    activity: AggregateContentActivity;
    admin_user?: Maybe<Admin_ModuleUserData>;
    artwork: Array<ClassroomImage>;
    class?: Maybe<Class>;
    /** @deprecated Field is no longer supported. Use class.id instead. */
    classId?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Field is no longer supported. Use class.slug instead. */
    classSlug: Scalars["String"]["output"];
    /** @deprecated Field is no longer supported. Use class.color instead. */
    color: Palette;
    contentType: ContentType;
    /** @deprecated Field is no longer supported. Will be removed without replacement. */
    createdAt: Scalars["String"]["output"];
    description?: Maybe<Scalars["Markdown"]["output"]>;
    duration: Scalars["Int"]["output"];
    id: Scalars["ID"]["output"];
    /** @deprecated Field is no longer supported. Use id instead. */
    legacyId?: Maybe<Scalars["String"]["output"]>;
    position: Scalars["Int"]["output"];
    quiz?: Maybe<ClassroomQuiz>;
    /** @deprecated Field is no longer supported. Use class.scripture instead. */
    scripture?: Maybe<Scalars["String"]["output"]>;
    seo: Seo;
    sessions?: Maybe<ModuleSessionConnection>;
    /** @deprecated Field is no longer supported. Use class.tags instead. */
    tags?: Maybe<Array<Tag>>;
    title: Scalars["String"]["output"];
    /** @deprecated Field is no longer supported. Will be removed without replacement. */
    updatedAt: Scalars["String"]["output"];
    user?: Maybe<ModuleUserData>;
  };

export type ModuleAdmin_UserArgs = {
  guid: Scalars["String"]["input"];
};

export type ModuleArtworkArgs = {
  aspectRatio?: InputMaybe<Scalars["AspectRatio"]["input"]>;
};

export type ModuleSessionConnection = {
  __typename?: "ModuleSessionConnection";
  edges: Array<ModuleSessionEdge>;
  nodes: Array<Session>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ModuleSessionEdge = {
  __typename?: "ModuleSessionEdge";
  cursor: Scalars["String"]["output"];
  node?: Maybe<Session>;
};

export type ModuleUserData = ContentUserData & {
  __typename?: "ModuleUserData";
  /** @deprecated Field is no longer supported. Use isComplete to determine completion. */
  completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  currentSession?: Maybe<Session>;
  id: Scalars["ID"]["output"];
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  isBookmarked: Scalars["Boolean"]["output"];
  isComplete: Scalars["Boolean"]["output"];
  progress?: Maybe<Scalars["Float"]["output"]>;
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  remainingDuration?: Maybe<Scalars["Int"]["output"]>;
};

/** A single movement within scripture */
export type MovementReading = {
  __typename?: "MovementReading";
  contentSelectionQuery?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  images: ImageSet;
  label?: Maybe<Scalars["String"]["output"]>;
  number?: Maybe<Scalars["Int"]["output"]>;
  recap?: Maybe<Recap>;
  relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  sequenceItemInfo?: Maybe<SequenceItemInfo>;
  studies?: Maybe<Array<Maybe<MovementStudy>>>;
  title: Scalars["String"]["output"];
  titleLong?: Maybe<Scalars["String"]["output"]>;
  units?: Maybe<Array<MovementReadingUnit>>;
};

/** A scripture reference range identifying an individual unit within a movement reading */
export type MovementReadingUnit = {
  __typename?: "MovementReadingUnit";
  absoluteOrder?: Maybe<Scalars["Int"]["output"]>;
  contentSelectionQuery?: Maybe<Scalars["String"]["output"]>;
  firstVerseId?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

/** Study information with Movement-specific sub-data */
export type MovementStudy = {
  __typename?: "MovementStudy";
  linkIds?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  patternType?: Maybe<PatternType>;
  study?: Maybe<Study>;
};

export type MultipleChoiceQuestion = ClassroomNode &
  QuizQuestionCommon & {
    __typename?: "MultipleChoiceQuestion";
    answer: Array<Scalars["String"]["output"]>;
    description: Scalars["String"]["output"];
    errorMessage: QuizQuestionFeedbackMessage;
    id: Scalars["ID"]["output"];
    /** @deprecated Field is no longer supported. Use id instead. */
    legacyId?: Maybe<Scalars["String"]["output"]>;
    options?: Maybe<Array<QuizQuestionOption>>;
    successMessage: QuizQuestionFeedbackMessage;
    title: Scalars["String"]["output"];
    type: QuizQuestionType;
    user?: Maybe<QuizQuestionUserData>;
  };

export type Mutation = {
  __typename?: "Mutation";
  /** Add a comment to a donation using the postGivingToken provided when the donation was initialized. */
  addDonationComment: Scalars["Boolean"]["output"];
  /** Delete an account from an authentication provider (Firebase) */
  admin_deleteAuthProviderAccount: Scalars["Boolean"]["output"];
  /** Change the email address for a user */
  admin_updateEmail: Admin_User;
  /** Cancels a users subscription */
  cancelSubscription: Scalars["Boolean"]["output"];
  /** Change the payment method used on the primary subscription for the current user, does nothing if there is no primary subscription */
  changePrimarySubscriptionPaymentMethod?: Maybe<DonationSubscription>;
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  createBookmark: Bookmarkable;
  createNote?: Maybe<Note>;
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  deleteBookmark: Bookmarkable;
  deleteNote: Note;
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  deleteQuizAnswersByClassSlug: Scalars["Boolean"]["output"];
  deleteSubscriptionPaymentMethod: Scalars["Boolean"]["output"];
  /** Get access token from valid login credentials. */
  login?: Maybe<LoginResponse>;
  markSessionComplete?: Maybe<Session>;
  /** Exchange a refresh token and nonce for a new authorization token and nonce */
  refreshAuthorization?: Maybe<RefreshAuthorizationResponse>;
  /** Register a new user account with email and password credentials */
  register?: Maybe<RegisterResponse>;
  registerDonationMatch: Scalars["Boolean"]["output"];
  /** Request deletion of the account of the currently logged-in user */
  requestAccountDeletion?: Maybe<RequestAccountDeletionResponse>;
  /** Send a password reset email */
  resetPassword?: Maybe<ResetPasswordResponse>;
  saveReflectionResponse?: Maybe<Reflection>;
  /** Set the status of a user's newsletter preference */
  setNewsletterPreference: NewsletterPreference;
  startAddSubscriptionPaymentMethod: AddSubscriptionPaymentMethod;
  startOneTimePayment: StripePayment;
  startSubscription: StripePayment;
  /** Submit a single user response to a survey about a piece of BibleProject content */
  submitContentSurvey: Scalars["Boolean"]["output"];
  submitFeedback?: Maybe<Class>;
  submitQuizAnswer?: Maybe<ClassroomQuizQuestion>;
  /** Subscribe an email address to one or more newsletters */
  subscribeToNewsletters: Scalars["Boolean"]["output"];
  unmarkSessionComplete?: Maybe<Session>;
  /** Record user completion status on a content item */
  updateContentCompletionStatus: UpdateContentCompletionStatusResponse;
  /** Record user engagement progress on a content items */
  updateContentProgress: UpdateContentProgressResponse;
  /** Update a donation with a comment for a logged in user */
  updateDonationWithComment: Donation;
  /**
   * Update the current user's email address.
   * Because authorization tokens have email addresses encoded in them, this mutation
   * will invalidate existing tokens.  Its response can include a new token.
   */
  updateEmail?: Maybe<UpdateEmailResponse>;
  updateNote?: Maybe<Note>;
  /** Change the currently authenticated user's password */
  updatePassword?: Maybe<UpdatePasswordResponse>;
  /** Change the password for a user identified by a token sent in a "forgot password" email */
  updatePasswordFromResetToken: UpdatePasswordResponse;
  updatePerkSelectionProfile: Scalars["Boolean"]["output"];
  updateSessionProgress?: Maybe<Session>;
  /**
   * Updates the existing subscription for the current user
   * returns the updated subscription or null if there was no subscription to update
   */
  updateSubscription?: Maybe<DonationSubscription>;
  /** Update the currently logged in user's profile. */
  updateUserProfile: Profile;
};

export type MutationAddDonationCommentArgs = {
  input: AddDonationCommentInput;
};

export type MutationAdmin_DeleteAuthProviderAccountArgs = {
  input: Admin_DeleteAuthProviderAccountInput;
};

export type MutationAdmin_UpdateEmailArgs = {
  input: Admin_UpdateEmailInput;
};

export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};

export type MutationChangePrimarySubscriptionPaymentMethodArgs = {
  input: ChangeActiveSubscriptionPaymentMethodInput;
};

export type MutationCreateBookmarkArgs = {
  input: BookmarkInput;
};

export type MutationCreateNoteArgs = {
  input: NoteInput;
};

export type MutationDeleteBookmarkArgs = {
  input: BookmarkInput;
};

export type MutationDeleteNoteArgs = {
  noteId: Scalars["ID"]["input"];
};

export type MutationDeleteQuizAnswersByClassSlugArgs = {
  classSlug: Scalars["String"]["input"];
};

export type MutationDeleteSubscriptionPaymentMethodArgs = {
  input: DeleteSubscriptionPaymentMethodInput;
};

export type MutationLoginArgs = {
  input: LoginInput;
};

export type MutationMarkSessionCompleteArgs = {
  sessionId: Scalars["ID"]["input"];
};

export type MutationRefreshAuthorizationArgs = {
  input: RefreshAuthorizationInput;
};

export type MutationRegisterArgs = {
  input: RegisterInput;
};

export type MutationRegisterDonationMatchArgs = {
  input: RegisterDonationMatchInput;
};

export type MutationRequestAccountDeletionArgs = {
  input?: InputMaybe<RequestAccountDeletionInput>;
};

export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};

export type MutationSaveReflectionResponseArgs = {
  input: ReflectionResponseInput;
};

export type MutationSetNewsletterPreferenceArgs = {
  input: SetNewsletterPreferenceInput;
};

export type MutationStartOneTimePaymentArgs = {
  input: OneTimePaymentInput;
};

export type MutationStartSubscriptionArgs = {
  input: SubscriptionInput;
};

export type MutationSubmitContentSurveyArgs = {
  input: SubmitContentSurveyInput;
};

export type MutationSubmitFeedbackArgs = {
  input: FeedbackInput;
};

export type MutationSubmitQuizAnswerArgs = {
  input: QuizAnswerInput;
};

export type MutationSubscribeToNewslettersArgs = {
  input: SubscribeToNewslettersInput;
};

export type MutationUnmarkSessionCompleteArgs = {
  sessionId: Scalars["ID"]["input"];
};

export type MutationUpdateContentCompletionStatusArgs = {
  input: UpdateContentCompletionStatusInput;
};

export type MutationUpdateContentProgressArgs = {
  input: UpdateContentProgressInput;
};

export type MutationUpdateDonationWithCommentArgs = {
  input: UpdateDonationWithCommentInput;
};

export type MutationUpdateEmailArgs = {
  input: UpdateEmailInput;
};

export type MutationUpdateNoteArgs = {
  input: NoteInput;
  noteId: Scalars["ID"]["input"];
};

export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};

export type MutationUpdatePasswordFromResetTokenArgs = {
  input: UpdatePasswordFromResetTokenInput;
};

export type MutationUpdatePerkSelectionProfileArgs = {
  input: UpdatePerkSelectionProfileInput;
};

export type MutationUpdateSessionProgressArgs = {
  input: SessionProgressInput;
};

export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};

export type MutationUpdateUserProfileArgs = {
  input?: InputMaybe<ProfileInput>;
};

/** An NT Write class */
export type NtWrightClass = {
  __typename?: "NTWrightClass";
  id: Scalars["ID"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
};

/** A BibleProject navigation element */
export type Navigation = {
  __typename?: "Navigation";
  downloads: Array<NavigationLinkItem>;
  featuredLanguages?: Maybe<NavigationFeaturedLanguages>;
  footer: NavigationFooter;
  header: Array<NavigationSection>;
  id: Scalars["ID"]["output"];
  labels: Array<NavigationLabelItem>;
  social: Array<NavigationLinkItem>;
};

/** A "support us" ad blob */
export type NavigationAsk = {
  __typename?: "NavigationAsk";
  action: NavigationLinkItem;
  content: Scalars["Markdown"]["output"];
};

/** Populates the Languages dropdown in the header */
export type NavigationFeaturedLanguages = {
  __typename?: "NavigationFeaturedLanguages";
  locales?: Maybe<Array<Locale>>;
  promo: NavigationPromo;
};

/** The content of a site footer */
export type NavigationFooter = {
  __typename?: "NavigationFooter";
  ask?: Maybe<NavigationAsk>;
  items: Array<NavigationLinkItem>;
};

/** A single label item; prev lang file entries (ie. global.header.search) */
export type NavigationLabelItem = {
  __typename?: "NavigationLabelItem";
  key: Scalars["String"]["output"];
  value: Scalars["NavigationLabelValue"]["output"];
};

/** A single linkable item (ie App Store, Facebook) */
export type NavigationLinkItem = {
  __typename?: "NavigationLinkItem";
  href: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  type?: Maybe<Scalars["String"]["output"]>;
};

/** A single promo, defining a nav dropdown area */
export type NavigationPromo = {
  __typename?: "NavigationPromo";
  href: Scalars["String"]["output"];
  image: Scalars["String"]["output"];
  subtitle?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
};

/** A generic section of the overall site navigation (e.g. "watch", "giving") */
export type NavigationSection = {
  __typename?: "NavigationSection";
  footer?: Maybe<Array<NavigationLinkItem>>;
  href?: Maybe<Scalars["String"]["output"]>;
  items?: Maybe<Array<NavigationLinkItem>>;
  label?: Maybe<Scalars["String"]["output"]>;
  promotion?: Maybe<NavigationPromo>;
};

/** A user-subscribable newsletter */
export type Newsletter = {
  __typename?: "Newsletter";
  type: NewsletterType;
};

/** A user's subscription preference for a newsletter */
export type NewsletterPreference = {
  __typename?: "NewsletterPreference";
  id: Scalars["ID"]["output"];
  newsletter: Newsletter;
  status: NewsletterPreferenceStatus;
};

/** The options for a user's preference selection for a newsletter */
export enum NewsletterPreferenceStatus {
  Subscribed = "Subscribed",
  Unsubscribed = "Unsubscribed",
}

/** The primary identifier for a newsletter */
export enum NewsletterType {
  Ambassador = "Ambassador",
  Classroom = "Classroom",
  GlobalSegment = "GlobalSegment",
  Newsletter = "Newsletter",
  Prayer = "Prayer",
  WeeklyPlaylist = "WeeklyPlaylist",
}

/** An item of arbitrary type, as specified in `relatedItemType` */
export type Node = {
  id: Scalars["ID"]["output"];
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
};

export type Note = ClassroomNode & {
  __typename?: "Note";
  color?: Maybe<NoteColor>;
  content: Scalars["String"]["output"];
  contentHtml: Scalars["HTML"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  isFavorited: Scalars["Boolean"]["output"];
  legacyId?: Maybe<Scalars["String"]["output"]>;
  session: Session;
  slide?: Maybe<Slide>;
  timestamp: Scalars["Int"]["output"];
};

export enum NoteColor {
  Cyan = "CYAN",
  Green = "GREEN",
  Orange = "ORANGE",
  Purple = "PURPLE",
  Red = "RED",
  White = "WHITE",
  Yellow = "YELLOW",
}

export type NoteInput = {
  color?: InputMaybe<NoteColor>;
  content?: InputMaybe<Scalars["String"]["input"]>;
  isFavorited?: InputMaybe<Scalars["Boolean"]["input"]>;
  sessionId?: InputMaybe<Scalars["ID"]["input"]>;
  timestamp?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Information to initialize a one time payment */
export type OneTimePaymentInput = {
  amount: Scalars["Int"]["input"];
  campaignCode?: InputMaybe<GivingCampaignCode>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  givenName?: InputMaybe<Scalars["String"]["input"]>;
  /** The device/browser language of the patron */
  languageLocale?: InputMaybe<Scalars["LanguageCode"]["input"]>;
  /** The language of the site or app that the patron is giving from */
  languageSource: Scalars["LanguageCode"]["input"];
  leadSource?: InputMaybe<Scalars["String"]["input"]>;
  /** Defaults to false - set to true if you are providing a perk selection experience */
  perkSelectionEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  surname?: InputMaybe<Scalars["String"]["input"]>;
};

export type OrderingQuestion = ClassroomNode &
  QuizQuestionCommon & {
    __typename?: "OrderingQuestion";
    answer: Array<Scalars["String"]["output"]>;
    description: Scalars["String"]["output"];
    errorMessage: QuizQuestionFeedbackMessage;
    id: Scalars["ID"]["output"];
    /** @deprecated Field is no longer supported. Use id instead. */
    legacyId?: Maybe<Scalars["String"]["output"]>;
    options?: Maybe<Array<QuizQuestionOption>>;
    successMessage: QuizQuestionFeedbackMessage;
    title: Scalars["String"]["output"];
    type: QuizQuestionType;
    user?: Maybe<QuizQuestionUserData>;
  };

/** A single page of the website */
export type Page = {
  __typename?: "Page";
  content: Scalars["Unist"]["output"];
  createdAt?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  meta: PageMeta;
  params?: Maybe<Scalars["JSONObject"]["output"]>;
  publishedAt: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["String"]["output"]>;
};

export type PageInfo = {
  __typename?: "PageInfo";
  endCursor?: Maybe<Scalars["String"]["output"]>;
  hasNextPage: Scalars["Boolean"]["output"];
  hasPreviousPage: Scalars["Boolean"]["output"];
  startCursor?: Maybe<Scalars["String"]["output"]>;
};

/** HTML meta tags for a page or data type */
export type PageMeta = {
  __typename?: "PageMeta";
  description?: Maybe<Scalars["String"]["output"]>;
  noIndex?: Maybe<Scalars["Boolean"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type Palette = {
  __typename?: "Palette";
  primary: Scalars["String"]["output"];
  secondary: Scalars["String"]["output"];
};

/** The type of pattern associating a movement and study */
export enum PatternType {
  Primary = "primary",
  Recall = "recall",
  Secondary = "secondary",
}

/** A supported payment processor */
export enum PaymentMethod {
  Cash = "Cash",
  Check = "Check",
  Other = "Other",
  Patreon = "Patreon",
  PayPal = "PayPal",
  Stripe = "Stripe",
  Wire = "Wire",
}

/** Status of a payment transaction */
export enum PaymentTransactionStatus {
  Disputed = "Disputed",
  Failed = "Failed",
  None = "None",
  Processing = "Processing",
  RefundCreated = "RefundCreated",
  RefundFailed = "RefundFailed",
  Refunded = "Refunded",
  Succeeded = "Succeeded",
}

/** Address connected to a user's profile */
export type PerkProfileAddress = {
  __typename?: "PerkProfileAddress";
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  postalCode?: Maybe<Scalars["String"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  streetAddress?: Maybe<Scalars["String"]["output"]>;
};

/** Input for updating a user's address during perk selection */
export type PerkProfileAddressInput = {
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  streetAddress?: InputMaybe<Scalars["String"]["input"]>;
  streetAddress2?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input for updating a user's profile during perk selection */
export type PerkProfileInput = {
  doNotDeliverAnyMail?: InputMaybe<Scalars["Boolean"]["input"]>;
  doNotDeliverPerks?: InputMaybe<Scalars["Boolean"]["input"]>;
  givenName?: InputMaybe<Scalars["String"]["input"]>;
  shippingAddress?: InputMaybe<PerkProfileAddressInput>;
  surname?: InputMaybe<Scalars["String"]["input"]>;
};

/** details about a perk selection and the user's profile required for perks */
export type PerkSelectionDetails = {
  __typename?: "PerkSelectionDetails";
  eligibleMilestone?: Maybe<EligibleMilestone>;
  profile: PerkSelectionProfile;
};

/** Get eligible perks */
export type PerkSelectionDetailsInput = {
  postGivingToken: Scalars["String"]["input"];
};

/** Public data required for the perk selection process */
export type PerkSelectionProfile = {
  __typename?: "PerkSelectionProfile";
  doNotDeliverAnyMail?: Maybe<Scalars["Boolean"]["output"]>;
  doNotDeliverPerks?: Maybe<Scalars["Boolean"]["output"]>;
  givenName?: Maybe<Scalars["String"]["output"]>;
  shippingAddress?: Maybe<PerkProfileAddress>;
  surname?: Maybe<Scalars["String"]["output"]>;
};

/** A person of note */
export type Person = Node &
  TimelineEventData & {
    __typename?: "Person";
    avatarUrl?: Maybe<Scalars["String"]["output"]>;
    biography?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    name: Scalars["String"]["output"];
    relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
    relatedItemType?: Maybe<Scalars["String"]["output"]>;
    timelineSeconds?: Maybe<Scalars["Int"]["output"]>;
    /** Author or Speaker */
    type?: Maybe<Scalars["String"]["output"]>;
  };

/** A selection of content */
export type Playlist = {
  __typename?: "Playlist";
  completionText?: Maybe<Scalars["Markdown"]["output"]>;
  createdAt: Scalars["String"]["output"];
  dateLabel?: Maybe<Scalars["String"]["output"]>;
  descriptionLong?: Maybe<Scalars["Markdown"]["output"]>;
  descriptionShort?: Maybe<Scalars["Markdown"]["output"]>;
  id: Scalars["ID"]["output"];
  images: ImageSet;
  items?: Maybe<Array<Maybe<PlaylistItem>>>;
  meta: PageMeta;
  next?: Maybe<Playlist>;
  previous?: Maybe<Playlist>;
  publishedAt: Scalars["String"]["output"];
  sectionLabel?: Maybe<Scalars["String"]["output"]>;
  sectionNum?: Maybe<Scalars["Int"]["output"]>;
  slug: Scalars["String"]["output"];
  subTitle?: Maybe<Scalars["String"]["output"]>;
  thumbnail: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
};

/** A type of content that can be included in a playlist */
export type PlaylistContent =
  | Article
  | BibleReading
  | BlogPost
  | PodcastChapter
  | Video;

/** An edge with a Playlist node from a connection */
export type PlaylistEdge = {
  __typename?: "PlaylistEdge";
  cursor: Scalars["String"]["output"];
  node: Playlist;
};

/** A single item in a playlist */
export type PlaylistItem = {
  __typename?: "PlaylistItem";
  content: PlaylistContent;
  highlightText?: Maybe<Scalars["Markdown"]["output"]>;
  id: Scalars["ID"]["output"];
};

/** A page of playlists with edges and pageInfo */
export type PlaylistsConnection = {
  __typename?: "PlaylistsConnection";
  edges: Array<PlaylistEdge>;
  pageInfo: PageInfo;
};

/** A title identifying the start of a chapter within a podcast episode */
export type PodcastChapter = Node & {
  __typename?: "PodcastChapter";
  audio?: Maybe<Scalars["String"]["output"]>;
  chapterNumber?: Maybe<Scalars["Int"]["output"]>;
  colors?: Maybe<ColorSet>;
  durationSeconds?: Maybe<Scalars["Int"]["output"]>;
  episode?: Maybe<PodcastEpisode>;
  id: Scalars["ID"]["output"];
  images: ImageSet;
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  segments?: Maybe<Array<Maybe<Segment>>>;
  slug: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

/** All information about a podcast episode */
export type PodcastEpisode = CoreLanguageContent &
  Node &
  TimelineEventData & {
    __typename?: "PodcastEpisode";
    activity: IndividualContentActivity;
    alternateLanguages: AlternateLanguagesConnection;
    /** example: #685842 */
    color?: Maybe<Scalars["String"]["output"]>;
    contentId: Scalars["String"]["output"];
    createdAt: Scalars["String"]["output"];
    credits?: Maybe<Scalars["String"]["output"]>;
    /** example: What does it mean to glorify God? Is it simply singing songs... */
    description: Scalars["Markdown"]["output"];
    /** @deprecated Use `durationSeconds` */
    durationMinutes?: Maybe<Scalars["Int"]["output"]>;
    durationSeconds?: Maybe<Scalars["Int"]["output"]>;
    episodeNumber?: Maybe<Scalars["Int"]["output"]>;
    id: Scalars["ID"]["output"];
    /** Different sized images for an item */
    images: ImageSet;
    label?: Maybe<Scalars["String"]["output"]>;
    language: ContentLanguage;
    /** An array of key learning points in the podcast */
    learnPoints?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    /**
     * The show notes which are not otherwise absorbed by table of contents, annotations,
     * or other purpose-built fields.
     * @deprecated Use `showNotes` instead.
     */
    legacyInformation?: Maybe<Scalars["Markdown"]["output"]>;
    meta: PageMeta;
    music: Array<Scalars["String"]["output"]>;
    path?: Maybe<Scalars["String"]["output"]>;
    podcastChapters?: Maybe<Array<Maybe<PodcastChapter>>>;
    /**
     * pattern: /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/
     * example: 2014-05-19 00:00:00
     * @deprecated Use `publishedAt` instead.
     */
    publishDate?: Maybe<Scalars["Date"]["output"]>;
    publishedAt?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use `relatedItems`. */
    relatedItemGroups?: Maybe<RelatedItemGroupsNamed>;
    /** @deprecated No longer used. */
    relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated No longer used. */
    relatedItemType?: Maybe<Scalars["String"]["output"]>;
    relatedItems?: Maybe<Array<Maybe<RelatedItem>>>;
    scriptureReferences?: Maybe<Array<Maybe<ScriptureReference>>>;
    sequenceItemInfo?: Maybe<SequenceItemInfo>;
    /** A subset of information about a podcast series */
    series?: Maybe<PodcastSeries>;
    /** Public URL for the web page for the episode */
    shareUrl?: Maybe<Scalars["String"]["output"]>;
    /** All information about a podcast */
    show?: Maybe<PodcastShow>;
    showNotes?: Maybe<Scalars["Markdown"]["output"]>;
    slug: Scalars["String"]["output"];
    /** example: 1 HR 10 MIN */
    subtitle?: Maybe<Scalars["String"]["output"]>;
    tableOfContents?: Maybe<Array<Maybe<PodcastTableOfContentsItem>>>;
    timelineEvents?: Maybe<Array<Maybe<TimelineEvent>>>;
    /** @deprecated Use `durationSeconds` */
    timelineSeconds?: Maybe<Scalars["Int"]["output"]>;
    /** example: Glory of God */
    title: Scalars["String"]["output"];
    transcriptDownloadUrl: Scalars["String"]["output"];
    updatedAt: Scalars["String"]["output"];
  };

/** All information about a podcast episode */
export type PodcastEpisodeAlternateLanguagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** All information about a podcast episode */
export type PodcastEpisodeRelatedItemsArgs = {
  predicates?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** The available sort properties for Podcast Episodes */
export enum PodcastEpisodeSortField {
  PublishedAt = "PUBLISHED_AT",
}

/** An instance of a episode sort input, providing a field and direction. */
export type PodcastEpisodeSortInput = {
  direction: SortEnum;
  field: PodcastEpisodeSortField;
};

/** A paginated list of podcast episodes */
export type PodcastEpisodesConnection = {
  __typename?: "PodcastEpisodesConnection";
  edges: Array<PodcastEpisodesEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A single podcast episode in a paginated list */
export type PodcastEpisodesEdge = {
  __typename?: "PodcastEpisodesEdge";
  cursor: Scalars["String"]["output"];
  node: PodcastEpisode;
};

/** All information about a podcast series */
export type PodcastSeries = CoreLanguageContent &
  Node &
  TimelineEventData & {
    __typename?: "PodcastSeries";
    activity: AggregateContentActivity;
    alternateLanguages: AlternateLanguagesConnection;
    color?: Maybe<Scalars["String"]["output"]>;
    contentId: Scalars["String"]["output"];
    description: Scalars["Markdown"]["output"];
    episodes?: Maybe<Array<Maybe<PodcastEpisode>>>;
    id: Scalars["ID"]["output"];
    images: ImageSet;
    label?: Maybe<Scalars["String"]["output"]>;
    language: ContentLanguage;
    meta: PageMeta;
    numEpisodes?: Maybe<Scalars["Int"]["output"]>;
    numEpisodesExpected?: Maybe<Scalars["Int"]["output"]>;
    publishedAt?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use `relatedItems`. */
    relatedItemGroups?: Maybe<RelatedItemGroupsNamed>;
    relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
    relatedItemType?: Maybe<Scalars["String"]["output"]>;
    relatedItems?: Maybe<Array<Maybe<RelatedItem>>>;
    /** The public URL for the series */
    shareUrl?: Maybe<Scalars["String"]["output"]>;
    slug: Scalars["String"]["output"];
    subtitle?: Maybe<Scalars["String"]["output"]>;
    timelineSeconds?: Maybe<Scalars["Int"]["output"]>;
    title: Scalars["String"]["output"];
    trailer?: Maybe<AudioTrailer>;
  };

/** All information about a podcast series */
export type PodcastSeriesAlternateLanguagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A paginated list of podcast series */
export type PodcastSeriesConnection = {
  __typename?: "PodcastSeriesConnection";
  edges: Array<PodcastSeriesEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A single podcast series in a paginated list */
export type PodcastSeriesEdge = {
  __typename?: "PodcastSeriesEdge";
  cursor: Scalars["String"]["output"];
  node: PodcastSeries;
};

/** The available sort properties for podcast series */
export enum PodcastSeriesSortField {
  PublishedAt = "PUBLISHED_AT",
}

/** An instance of a podcast series sort input, providing a field and direction. */
export type PodcastSeriesSortInput = {
  direction: SortEnum;
  field: PodcastSeriesSortField;
};

/** A podcast that may contain many series and episodes */
export type PodcastShow = CoreLanguageContent & {
  __typename?: "PodcastShow";
  alternateLanguages: AlternateLanguagesConnection;
  bannerPhoto?: Maybe<Scalars["String"]["output"]>;
  color?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["String"]["output"];
  description: Scalars["Markdown"]["output"];
  episodes?: Maybe<PodcastEpisodesConnection>;
  googlePodcastLink?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  /** @deprecated Use images field instead */
  image?: Maybe<ImageSet>;
  images: ImageSet;
  label?: Maybe<Scalars["String"]["output"]>;
  language: ContentLanguage;
  meta: PageMeta;
  publishedAt: Scalars["String"]["output"];
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  series?: Maybe<PodcastSeriesConnection>;
  shareUrl?: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
  sourceUrl: Scalars["String"]["output"];
  spotifyLink: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
  youtubeLink: Scalars["String"]["output"];
};

/** A podcast that may contain many series and episodes */
export type PodcastShowAlternateLanguagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A podcast that may contain many series and episodes */
export type PodcastShowEpisodesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A podcast that may contain many series and episodes */
export type PodcastShowSeriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A single entry in table of contents */
export type PodcastTableOfContentsItem = {
  __typename?: "PodcastTableOfContentsItem";
  endSeconds: Scalars["Int"]["output"];
  startSeconds: Scalars["Int"]["output"];
  timeLabel: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

/** A single poster */
export type Poster = {
  __typename?: "Poster";
  createdAt?: Maybe<Scalars["String"]["output"]>;
  description: Scalars["Markdown"]["output"];
  filePath: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  image?: Maybe<ImageSet>;
  lang: Scalars["String"]["output"];
  publishedAt: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["String"]["output"]>;
};

/** Personal information about a user */
export type Profile = {
  __typename?: "Profile";
  avatar?: Maybe<Avatar>;
  /** @deprecated Use `createdAtDate`. */
  createdAt?: Maybe<Scalars["String"]["output"]>;
  createdAtDate?: Maybe<Scalars["Date"]["output"]>;
  doNotDeliverAnyMail: Scalars["Boolean"]["output"];
  doNotDeliverPerks: Scalars["Boolean"]["output"];
  /** @deprecated Use `givenName`. */
  firstName?: Maybe<Scalars["String"]["output"]>;
  /** The user's first/given name */
  givenName: Scalars["String"]["output"];
  /** @deprecated Use `publicId` and/or `email. */
  id?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use `surname`. */
  lastName?: Maybe<Scalars["String"]["output"]>;
  preferredLanguage?: Maybe<Scalars["LanguageCode"]["output"]>;
  /**
   * The public ID used to identify a user in analytics
   * @deprecated Use `User.publicId`.
   */
  publicId?: Maybe<Scalars["String"]["output"]>;
  shippingAddress?: Maybe<ProfileAddress>;
  /**
   * A user's mailing preferences
   * @deprecated Use `doNotDeliverAnyMail`.
   */
  shouldNotDeliverAnyMail?: Maybe<Scalars["Boolean"]["output"]>;
  /** @deprecated Use `doNotDeliverPerks`. */
  shouldNotDeliverGifts?: Maybe<Scalars["Boolean"]["output"]>;
  /** The user's last/family name */
  surname?: Maybe<Scalars["String"]["output"]>;
  verifiedShippingAddress: Scalars["Boolean"]["output"];
};

/** An address connected to a user's profile */
export type ProfileAddress = {
  __typename?: "ProfileAddress";
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  phone?: Maybe<Scalars["String"]["output"]>;
  postalCode?: Maybe<Scalars["String"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  streetAddress?: Maybe<Scalars["String"]["output"]>;
};

/** Input to update a profile address */
export type ProfileAddressInput = {
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  streetAddress?: InputMaybe<Scalars["String"]["input"]>;
  streetAddress2?: InputMaybe<Scalars["String"]["input"]>;
};

/** User-editable profile information */
export type ProfileInput = {
  avatar?: InputMaybe<AvatarInput>;
  doNotDeliverAnyMail?: InputMaybe<Scalars["Boolean"]["input"]>;
  doNotDeliverPerks?: InputMaybe<Scalars["Boolean"]["input"]>;
  givenName?: InputMaybe<Scalars["String"]["input"]>;
  preferredLanguage?: InputMaybe<Scalars["LanguageCode"]["input"]>;
  shippingAddress?: InputMaybe<ProfileAddressInput>;
  surname?: InputMaybe<Scalars["String"]["input"]>;
};

/** Public details of a donation */
export type PublicDonationComment = {
  __typename?: "PublicDonationComment";
  comment: Scalars["String"]["output"];
  currency: CurrencyCode;
  frequency: DonationFrequency;
  user: PublicDonationUser;
};

/** A connection to a list of `PublicDonationComment` values. */
export type PublicDonationCommentConnection = {
  __typename?: "PublicDonationCommentConnection";
  edges: Array<PublicDonationCommentEdge>;
  pageInfo: PageInfo;
};

/** An edge containing a `PublicDonationComment` and its cursor. */
export type PublicDonationCommentEdge = {
  __typename?: "PublicDonationCommentEdge";
  cursor: Scalars["String"]["output"];
  node: PublicDonationComment;
};

/** Public details of a user who has made a donation */
export type PublicDonationUser = {
  __typename?: "PublicDonationUser";
  avatar?: Maybe<Avatar>;
  city?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  lastInitial?: Maybe<Scalars["String"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
};

export type Query = {
  __typename?: "Query";
  /** Get user data accessible by administrators */
  admin_user?: Maybe<Admin_User>;
  article?: Maybe<Article>;
  /**
   * Retrieve multiple articles.
   *
   * - first / after:
   *     - part of the relay spec;
   *     - if after is provided, first must be provided.
   * - last / before:
   *     - part of the relay spec;
   *     - if before is provided, last must be provided.
   * - first and last cannot be provided at the same time.
   * - ignoreExclusions:
   *     - Bypasses the default of hiding videos that are not included in the main catalog.
   */
  articles?: Maybe<ArticlesConnection>;
  autocomplete: Array<Scalars["String"]["output"]>;
  avatar?: Maybe<Avatar>;
  avatars?: Maybe<Array<Maybe<Avatar>>>;
  bibleBook?: Maybe<BibleBook>;
  /**
   * Retrieve multiple Bible books.
   *
   * - sort:
   *     - relies on the relay spec
   *     - It accepts multiple sort inputs, and processes them in the order provided.
   * - first / after:
   *     - part of the relay spec;
   *     - if after is provided, first must be provided.
   * - last / before:
   *     - part of the relay spec;
   *     - if before is provided, last must be provided.
   * - first and last cannot be provided at the same time.
   */
  bibleBooks?: Maybe<BibleBooksConnection>;
  /** @deprecated Use 'BibleText' instead. */
  bibleChapter?: Maybe<BibleChapter>;
  /** @deprecated Use 'BibleText' instead. */
  bibleChapters?: Maybe<BibleChaptersConnection>;
  /** @deprecated Use 'BibleText' instead. */
  bibleCollection?: Maybe<BibleCollection>;
  /** @deprecated Use 'BibleText' instead. */
  bibleCollections?: Maybe<Array<Maybe<BibleCollection>>>;
  /** @deprecated Use 'BibleText' instead. */
  bibleContent?: Maybe<BibleContentResponse>;
  bibleReading?: Maybe<BibleReading>;
  bibleText?: Maybe<BibleText>;
  bibleTranslation?: Maybe<BibleTranslation>;
  bibleTranslations?: Maybe<BibleTranslationsConnection>;
  /** @deprecated Use 'BibleText' instead. */
  bibleVerse?: Maybe<BibleVerse>;
  /** @deprecated Use 'BibleText' instead. */
  bibleVerses?: Maybe<BibleVersesConnection>;
  billingScheduleChangePreview: BillingScheduleChangePreviewResponse;
  /** @deprecated Use article instead */
  blogPost?: Maybe<BlogPost>;
  classBySlug?: Maybe<Class>;
  /**
   * A list of all released classes, grouped by categories such as
   * "Old Testament" and "New Testament"
   */
  classCategories: Array<ClassCategory>;
  classes?: Maybe<Array<Maybe<Class>>>;
  contentBundle?: Maybe<ContentBundle>;
  contentLanguage?: Maybe<ContentLanguage>;
  contentLanguages: Array<ContentLanguage>;
  donation: Donation;
  donationMatchCompany: DonationMatchCompanyResult;
  experimentalConfig?: Maybe<ExperimentalConfig>;
  experimental_guide?: Maybe<Experimental_Guide>;
  experimental_guides?: Maybe<Array<Experimental_Guide>>;
  /** @deprecated Explore Item is no longer supported. */
  exploreItemById?: Maybe<ExploreItem>;
  /** @deprecated Use givingConfigurations instead */
  givingCampaign?: Maybe<GivingCampaign>;
  /** Configuration for content and default values associated with giving flows. */
  givingConfigurations: GivingConfigurations;
  guideCategories?: Maybe<Array<GuideCategory>>;
  guideCategory?: Maybe<GuideCategory>;
  /** @deprecated Journey is no longer supported. */
  journey?: Maybe<JourneyConnection>;
  literaryDesign?: Maybe<LiteraryDesign>;
  /** Get currently authenticated user. */
  me?: Maybe<User>;
  moduleByPosition?: Maybe<Module>;
  /** @deprecated Journey is no longer supported. */
  movementReading?: Maybe<MovementReading>;
  navigation?: Maybe<Navigation>;
  /** Get available newsletters */
  newsletters: Array<Newsletter>;
  noteById?: Maybe<Note>;
  notes?: Maybe<Array<Maybe<Note>>>;
  page?: Maybe<Page>;
  perkSelectionDetails: PerkSelectionDetails;
  playlist?: Maybe<Playlist>;
  playlists: PlaylistsConnection;
  playlistsBySection: Array<Playlist>;
  podcastChapter?: Maybe<PodcastChapter>;
  podcastEpisode?: Maybe<PodcastEpisode>;
  /**
   * Retrieve multiple podcast episodes.
   *
   * - sort:
   *     - relies on the relay spec
   *     - It accepts multiple sort inputs, and processes them in the order provided.
   *     - If sort is used, sortBy is ignored.
   * - first / after:
   *     - part of the relay spec;
   *     - if after is provided, first must be provided.
   * - last / before:
   *     - part of the relay spec;
   *     - if before is provided, last must be provided.
   * - first and last cannot be provided at the same time.
   * - deprecated:
   *     - search (no longer supported)
   *     - sortBy (use `sort` instead)
   */
  podcastEpisodes?: Maybe<PodcastEpisodesConnection>;
  podcastSeries?: Maybe<PodcastSeries>;
  /**
   * Retrieve multiple podcast series.
   *
   * - sort:
   *     - relies on the relay spec
   *     - It accepts multiple sort inputs, and processes them in the order provided.
   *     - If sort is used, sortBy is ignored.
   * - first / after:
   *     - part of the relay spec;
   *     - if after is provided, first must be provided.
   * - last / before:
   *     - part of the relay spec;
   *     - if before is provided, last must be provided.
   * - first and last cannot be provided at the same time.
   * - deprecated:
   *     - search (no longer supported)
   *     - sortBy (use `sort` instead)
   */
  podcastSeriesList?: Maybe<PodcastSeriesConnection>;
  podcastShow?: Maybe<PodcastShow>;
  podcastShows: Array<PodcastShow>;
  poster?: Maybe<Poster>;
  posters?: Maybe<Array<Poster>>;
  publicDonationComments: PublicDonationCommentConnection;
  quizByPosition?: Maybe<ClassroomQuiz>;
  readingPlan?: Maybe<ReadingPlan>;
  readingPlans: Array<ReadingPlan>;
  scriptReference?: Maybe<ScriptReference>;
  scriptReferences?: Maybe<Array<ScriptReference>>;
  search?: Maybe<SearchConnection>;
  serviceInfo: GlobalSystemInfo;
  sessionByPosition?: Maybe<Session>;
  simpleEssay?: Maybe<SimpleEssay>;
  /** @deprecated Journey is no longer supported. */
  skills?: Maybe<SkillsConnection>;
  /** public key for the Stripe API */
  stripePublishableKey: Scalars["String"]["output"];
  /** @deprecated Journey is no longer supported. */
  study?: Maybe<Study>;
  studyNote?: Maybe<StudyNote>;
  studyNotes?: Maybe<Array<StudyNote>>;
  studyWord?: Maybe<StudyWord>;
  /**
   * Retrieve multiple study words.
   *
   * - sort:
   *     - relies on the relay spec
   *     - It accepts multiple sort inputs, and processes them in the order provided.
   * - first / after:
   *     - part of the relay spec;
   *     - if after is provided, first must be provided.
   * - last / before:
   *     - part of the relay spec;
   *     - if before is provided, last must be provided.
   * - first and last cannot be provided at the same time.
   */
  studyWords?: Maybe<StudyWordsConnection>;
  subscription: DonationSubscription;
  subscriptionPaymentMethod: SubscriptionPaymentMethod;
  teacherNotes?: Maybe<TeacherNotes>;
  unstable_slides?: Maybe<UnstableSlides>;
  userAudio?: Maybe<UserAudio>;
  /**
   * Retrieve multiple user audios.
   *
   * - sort:
   *     - relies on the relay spec
   *     - It accepts multiple sort inputs, and processes them in the order provided.
   * - first / after:
   *     - part of the relay spec;
   *     - if after is provided, first must be provided.
   * - last / before:
   *     - part of the relay spec;
   *     - if before is provided, last must be provided.
   * - first and last cannot be provided at the same time.
   */
  userAudios?: Maybe<UserAudiosConnection>;
  video?: Maybe<Video>;
  /**
   * Retrieve multiple video categories.
   *
   * - sort:
   *     - relies on the relay spec
   *     - It accepts multiple sort inputs, and processes them in the order provided.
   *     - If sort is used, sortBy is ignored.
   * - first / after:
   *     - part of the relay spec;
   *     - if after is provided, first must be provided.
   * - last / before:
   *     - part of the relay spec;
   *     - if before is provided, last must be provided.
   * - first and last cannot be provided at the same time.
   * - deprecated:
   *     - search (no longer supported)
   *     - sortBy (use `sort` instead)
   */
  videoCategories?: Maybe<VideoCategoriesConnection>;
  /** Fetch a single video category */
  videoCategory?: Maybe<VideoCategory>;
  /** Fetch a single video collection */
  videoCollection?: Maybe<VideoCollection>;
  /** Fetch a list of video collections. */
  videoCollectionsList?: Maybe<Array<VideoCollection>>;
  /**
   * Retrieve multiple videos.
   *
   * - sort:
   *     - relies on the relay spec
   *     - It accepts multiple sort inputs, and processes them in the order provided.
   *     - If sort is used, sortBy is ignored.
   * - first / after:
   *     - part of the relay spec;
   *     - if after is provided, first must be provided.
   * - last / before:
   *     - part of the relay spec;
   *     - if before is provided, last must be provided.
   * - first and last cannot be provided at the same time.
   * - ignoreExclusions:
   *     - Bypasses the default of hiding videos that are not included in the main catalog.
   * - videoIds:
   *     - Will find videos in this array of IDs
   *     - If provided, ignores exclusions and sorting.
   * - deprecated:
   *     - search (no longer supported)
   *     - sortBy (use `sort` instead)
   */
  videos?: Maybe<VideosConnection>;
  visual?: Maybe<Visual>;
};

export type QueryAdmin_UserArgs = {
  input: AdminUserInput;
};

export type QueryArticleArgs = {
  id?: InputMaybe<Scalars["Identifier"]["input"]>;
};

export type QueryArticlesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  ignoreExclusions?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryAutocompleteArgs = {
  query: Scalars["String"]["input"];
};

export type QueryAvatarArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryBibleBookArgs = {
  bibleBookId: Scalars["ID"]["input"];
};

export type QueryBibleBooksArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<BibleBookSortInput>>;
};

export type QueryBibleChapterArgs = {
  bibleChapterId: Scalars["ID"]["input"];
};

export type QueryBibleChaptersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  bibleBookId: Scalars["ID"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryBibleCollectionArgs = {
  bibleCollectionTag: CollectionTag;
};

export type QueryBibleContentArgs = {
  query: Scalars["String"]["input"];
  translationId: Scalars["ID"]["input"];
};

export type QueryBibleReadingArgs = {
  id?: InputMaybe<Scalars["Identifier"]["input"]>;
  translation?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryBibleTextArgs = {
  query?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryBibleTranslationArgs = {
  name: Scalars["String"]["input"];
};

export type QueryBibleTranslationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<BibleTranslationSortInput>>;
};

export type QueryBibleVerseArgs = {
  bibleVerseId: Scalars["ID"]["input"];
};

export type QueryBibleVersesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  bibleChapterId: Scalars["ID"]["input"];
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryBillingScheduleChangePreviewArgs = {
  input: BillingScheduleChangePreviewInput;
};

export type QueryBlogPostArgs = {
  blogPostId: Scalars["ID"]["input"];
};

export type QueryClassBySlugArgs = {
  classSlug: Scalars["String"]["input"];
};

export type QueryContentBundleArgs = {
  id: Scalars["Identifier"]["input"];
};

export type QueryContentLanguageArgs = {
  id?: InputMaybe<Scalars["Identifier"]["input"]>;
};

export type QueryDonationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryDonationMatchCompanyArgs = {
  input: DonationMatchCompanyInput;
};

export type QueryExperimentalConfigArgs = {
  namespace: Scalars["String"]["input"];
  version: Scalars["Int"]["input"];
};

export type QueryExperimental_GuideArgs = {
  identifier: Scalars["Identifier"]["input"];
};

export type QueryExperimental_GuidesArgs = {
  categoryId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryExploreItemByIdArgs = {
  exploreItemId: Scalars["ID"]["input"];
};

export type QueryGivingCampaignArgs = {
  campaignCode: Scalars["String"]["input"];
};

export type QueryGuideCategoryArgs = {
  identifier: Scalars["Identifier"]["input"];
};

export type QueryJourneyArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryLiteraryDesignArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryModuleByPositionArgs = {
  classSlug: Scalars["String"]["input"];
  modulePosition: Scalars["Int"]["input"];
};

export type QueryMovementReadingArgs = {
  movementId: Scalars["ID"]["input"];
};

export type QueryNoteByIdArgs = {
  noteId: Scalars["ID"]["input"];
};

export type QueryNotesArgs = {
  classSlug: Scalars["String"]["input"];
  sessionId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryPageArgs = {
  id: Scalars["Identifier"]["input"];
};

export type QueryPerkSelectionDetailsArgs = {
  input: PerkSelectionDetailsInput;
};

export type QueryPlaylistArgs = {
  id?: InputMaybe<Scalars["Identifier"]["input"]>;
  latest?: InputMaybe<Scalars["Boolean"]["input"]>;
  translation?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryPlaylistsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  translation?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryPlaylistsBySectionArgs = {
  section: Scalars["Int"]["input"];
  translation?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryPodcastChapterArgs = {
  id?: InputMaybe<Scalars["Identifier"]["input"]>;
};

export type QueryPodcastEpisodeArgs = {
  id?: InputMaybe<Scalars["Identifier"]["input"]>;
};

export type QueryPodcastEpisodesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  episodeIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  showId?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<Array<PodcastEpisodeSortInput>>;
};

export type QueryPodcastSeriesArgs = {
  id?: InputMaybe<Scalars["Identifier"]["input"]>;
};

export type QueryPodcastSeriesListArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  seriesIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  showId?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<Array<PodcastSeriesSortInput>>;
};

export type QueryPodcastShowArgs = {
  id: Scalars["Identifier"]["input"];
};

export type QueryPosterArgs = {
  id?: InputMaybe<Scalars["Identifier"]["input"]>;
};

export type QueryPublicDonationCommentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryQuizByPositionArgs = {
  classSlug: Scalars["String"]["input"];
  quizPosition: Scalars["Int"]["input"];
};

export type QueryReadingPlanArgs = {
  identifier: Scalars["Identifier"]["input"];
};

export type QueryReadingPlansArgs = {
  featured?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryScriptReferenceArgs = {
  id?: InputMaybe<Scalars["Identifier"]["input"]>;
};

export type QuerySearchArgs = {
  page?: InputMaybe<Scalars["Int"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  query: Scalars["String"]["input"];
};

export type QuerySessionByPositionArgs = {
  classSlug: Scalars["String"]["input"];
  sessionPosition: Scalars["Int"]["input"];
};

export type QuerySimpleEssayArgs = {
  id: Scalars["Identifier"]["input"];
};

export type QuerySkillsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryStudyArgs = {
  studyId: Scalars["ID"]["input"];
};

export type QueryStudyNoteArgs = {
  id?: InputMaybe<Scalars["Identifier"]["input"]>;
};

export type QueryStudyWordArgs = {
  id?: InputMaybe<Scalars["Identifier"]["input"]>;
};

export type QueryStudyWordsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<StudyWordSortInput>>;
};

export type QuerySubscriptionArgs = {
  id: Scalars["ID"]["input"];
};

export type QuerySubscriptionPaymentMethodArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryTeacherNotesArgs = {
  sessionId: Scalars["ID"]["input"];
};

export type QueryUnstable_SlidesArgs = {
  sessionId: Scalars["ID"]["input"];
};

export type QueryUserAudioArgs = {
  identifier: Scalars["Identifier"]["input"];
};

export type QueryUserAudiosArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<UserAudioSortInput>>;
};

export type QueryVideoArgs = {
  id?: InputMaybe<Scalars["Identifier"]["input"]>;
};

export type QueryVideoCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  featuredOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryVideoCategoryArgs = {
  categoryId: Scalars["ID"]["input"];
};

export type QueryVideoCollectionArgs = {
  id: Scalars["Identifier"]["input"];
};

export type QueryVideoCollectionsListArgs = {
  sortBy?: InputMaybe<SortEnum>;
  type?: InputMaybe<VideoCollectionTypeEnum>;
};

export type QueryVideosArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  ignoreExclusions?: InputMaybe<Scalars["Boolean"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<VideoSortInput>>;
  videoIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type QueryVisualArgs = {
  id: Scalars["ID"]["input"];
};

/** A quiz containing one or more questions */
export type Quiz = Node & {
  __typename?: "Quiz";
  id: Scalars["ID"]["output"];
  questions?: Maybe<Array<QuizQuestion>>;
  relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  sequenceItemInfo?: Maybe<SequenceItemInfo>;
  title: Scalars["String"]["output"];
};

export type QuizAnswerInput = {
  questionId: Scalars["ID"]["input"];
  value?: InputMaybe<Scalars["String"]["input"]>;
};

/** One question within a quiz */
export type QuizQuestion = {
  __typename?: "QuizQuestion";
  answers: Array<QuizQuestionAnswer>;
  id: Scalars["ID"]["output"];
  question: Scalars["String"]["output"];
};

/** The answer to a quiz question */
export type QuizQuestionAnswer = {
  __typename?: "QuizQuestionAnswer";
  answer: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isCorrect: Scalars["Boolean"]["output"];
};

export type QuizQuestionCommon = {
  answer: Array<Scalars["String"]["output"]>;
  description: Scalars["String"]["output"];
  errorMessage: QuizQuestionFeedbackMessage;
  id: Scalars["ID"]["output"];
  options?: Maybe<Array<QuizQuestionOption>>;
  successMessage: QuizQuestionFeedbackMessage;
  title: Scalars["String"]["output"];
  type: QuizQuestionType;
  user?: Maybe<QuizQuestionUserData>;
};

export type QuizQuestionFeedbackMessage = {
  __typename?: "QuizQuestionFeedbackMessage";
  description: Scalars["String"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type QuizQuestionItem = {
  __typename?: "QuizQuestionItem";
  content: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

export type QuizQuestionOption = {
  __typename?: "QuizQuestionOption";
  content: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
};

export enum QuizQuestionType {
  FillInBlank = "FILL_IN_BLANK",
  Matching = "MATCHING",
  MultipleChoice = "MULTIPLE_CHOICE",
  Ordering = "ORDERING",
  Response = "RESPONSE",
  SingleChoice = "SINGLE_CHOICE",
  Survey = "SURVEY",
  TrueFalse = "TRUE_FALSE",
}

export type QuizQuestionUserData = {
  __typename?: "QuizQuestionUserData";
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  answer?: Maybe<Scalars["String"]["output"]>;
  completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  isCorrect?: Maybe<Scalars["Boolean"]["output"]>;
};

export type QuizUserData = {
  __typename?: "QuizUserData";
  completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  currentSession?: Maybe<Session>;
  id: Scalars["ID"]["output"];
  progress?: Maybe<Scalars["Float"]["output"]>;
};

/** A quote attributed to some person */
export type Quote = TimelineEventData & {
  __typename?: "Quote";
  byline?: Maybe<Scalars["String"]["output"]>;
  relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
  timelineSeconds?: Maybe<Scalars["Int"]["output"]>;
};

/** A single reading plan */
export type ReadingPlan = {
  __typename?: "ReadingPlan";
  createdAt: Scalars["String"]["output"];
  durationDays?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  image?: Maybe<ImageSet>;
  isFeatured: Scalars["Boolean"]["output"];
  publishedAt: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

/** A short rephrasing of the content of a movement */
export type Recap = {
  __typename?: "Recap";
  content?: Maybe<Scalars["String"]["output"]>;
  image?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type Reflection = ClassroomNode & {
  __typename?: "Reflection";
  id: Scalars["ID"]["output"];
  /** @deprecated Field is no longer supported. Use id instead. */
  legacyId?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Field is no longer supported. Use questionHtml instead. */
  question?: Maybe<Scalars["String"]["output"]>;
  questionHtml: Scalars["HTML"]["output"];
  /** @deprecated Field is no longer supported. Use responseHtml instead. */
  response?: Maybe<Scalars["String"]["output"]>;
  responseHtml: Scalars["HTML"]["output"];
  session: Session;
  user?: Maybe<ReflectionUserData>;
};

export type ReflectionResponseInput = {
  content: Scalars["String"]["input"];
  reflectionId: Scalars["ID"]["input"];
};

/** A set of intro and outro Reflections */
export type ReflectionSet = {
  __typename?: "ReflectionSet";
  intro: Scalars["Markdown"]["output"];
  outro: Scalars["Markdown"]["output"];
};

export type ReflectionUserData = {
  __typename?: "ReflectionUserData";
  content?: Maybe<Scalars["String"]["output"]>;
  contentHtml?: Maybe<Scalars["HTML"]["output"]>;
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
};

/** Input for the `refreshAuthorization` mutation */
export type RefreshAuthorizationInput = {
  nonce: Scalars["String"]["input"];
  refreshToken: Scalars["String"]["input"];
};

/** The response to a request to exchange a refresh token for an authorization token */
export type RefreshAuthorizationResponse = {
  __typename?: "RefreshAuthorizationResponse";
  /** A one-time string that must be included the next time the same refresh token is exchanged for a new authorization token */
  nonce?: Maybe<Scalars["String"]["output"]>;
  /** A new bearer token to be included in an "Authorization" header */
  token?: Maybe<Scalars["String"]["output"]>;
};

/** Input for registering a donation match */
export type RegisterDonationMatchInput = {
  companyId: Scalars["Int"]["input"];
  postGivingToken: Scalars["String"]["input"];
};

/** Input for the `register` mutation */
export type RegisterInput = {
  email: Scalars["String"]["input"];
  givenName: Scalars["String"]["input"];
  /** The device/browser language */
  languageLocale?: InputMaybe<Scalars["LanguageCode"]["input"]>;
  /** The language of the site or app */
  languageSource?: InputMaybe<Scalars["LanguageCode"]["input"]>;
  leadSource?: InputMaybe<Scalars["String"]["input"]>;
  password: Scalars["String"]["input"];
  surname: Scalars["String"]["input"];
};

/** User registration response */
export type RegisterResponse = {
  __typename?: "RegisterResponse";
  authorization?: Maybe<Authorization>;
  user?: Maybe<User>;
};

/** A content item related to another item */
export type RelatedItem =
  | Article
  | BibleReading
  | BibleText
  | BlogPost
  | BookReference
  | Class
  | ContentBundle
  | Course
  | Experimental_Guide
  | ExploreItem
  | GuideCategory
  | MovementReading
  | NtWrightClass
  | Person
  | Playlist
  | PodcastChapter
  | PodcastEpisode
  | PodcastSeries
  | PodcastShow
  | Poster
  | Quiz
  | ReadingPlan
  | RelatedItemGroup
  | Resource
  | ScriptReference
  | ScriptureReference
  | Session
  | StructuredContent
  | Study
  | StudyLesson
  | StudyNote
  | StudyWord
  | Video
  | VideoCategory
  | VideoClip
  | VideoCollection
  | WebReference;

/** A named group of related items */
export type RelatedItemGroup = {
  __typename?: "RelatedItemGroup";
  action?: Maybe<Action>;
  description: Scalars["Markdown"]["output"];
  id: Scalars["ID"]["output"];
  items?: Maybe<Array<Maybe<RelatedItem>>>;
  /**
   * Provides a hint to client consumers about how
   * this group of items would like to be displayed
   */
  preferredStyle: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

/** Related items organized into groups by key */
export type RelatedItemGroupsNamed = {
  __typename?: "RelatedItemGroupsNamed";
  exploreMore?: Maybe<ClassicRelatedItemGroup>;
  relatedPodcast?: Maybe<ClassicRelatedItemGroup>;
  relatedReads?: Maybe<ClassicRelatedItemGroup>;
  relatedStudies?: Maybe<ClassicRelatedItemGroup>;
  relatedVideo?: Maybe<ClassicRelatedItemGroup>;
};

/** A connection between content items */
export type RelationshipConnection = {
  __typename?: "RelationshipConnection";
  edges: Array<RelationshipEdge>;
  nodes: Array<RelatedItem>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** A single relationship between content items */
export type RelationshipEdge = {
  __typename?: "RelationshipEdge";
  cursor: Scalars["String"]["output"];
  node: RelatedItem;
  params: Scalars["JSONObject"]["output"];
  predicate: Scalars["String"]["output"];
  verseRanges: Array<VerseRange>;
};

/** Input for the `requestAccountDeletion` mutation */
export type RequestAccountDeletionInput = {
  requestSource?: InputMaybe<Scalars["String"]["input"]>;
};

/** Response to a request for account deletion */
export type RequestAccountDeletionResponse = {
  __typename?: "RequestAccountDeletionResponse";
  /** The user's email address */
  email?: Maybe<Scalars["String"]["output"]>;
};

/** Input for the `resetPassword` mutation */
export type ResetPasswordInput = {
  email: Scalars["String"]["input"];
};

/** Response to a request for a reset password email */
export type ResetPasswordResponse = {
  __typename?: "ResetPasswordResponse";
  message?: Maybe<Scalars["String"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Information about a downloadable file */
export type Resource = Node & {
  __typename?: "Resource";
  category?: Maybe<Category>;
  /** Absolute URL to access the file directly */
  directUrl?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  sequenceItemInfo?: Maybe<SequenceItemInfo>;
  title: Scalars["String"]["output"];
  /** Absolute URL to download the file */
  url?: Maybe<Scalars["String"]["output"]>;
};

/** A web link embedded in an article */
export type ResourceLink = {
  __typename?: "ResourceLink";
  hash: Scalars["String"]["output"];
  item?: Maybe<RelatedItem>;
  url: Scalars["String"]["output"];
};

export enum Role {
  Admin = "ADMIN",
  Author = "AUTHOR",
  Superadmin = "SUPERADMIN",
  User = "USER",
}

export type Seo = {
  __typename?: "SEO";
  description: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

/** A single script reference */
export type ScriptReference = {
  __typename?: "ScriptReference";
  createdAt?: Maybe<Scalars["String"]["output"]>;
  description: Scalars["Markdown"]["output"];
  filePath: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  image?: Maybe<ImageSet>;
  lang: Scalars["String"]["output"];
  publishedAt: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["String"]["output"]>;
};

/** The content of a scripture section in an article */
export type ScriptureObj = {
  __typename?: "ScriptureObj";
  scriptureContent?: Maybe<Scalars["String"]["output"]>;
  scriptureReference?: Maybe<Scalars["String"]["output"]>;
};

/** A reference to a specific location in the Bible */
export type ScriptureReference = Node &
  TimelineEventData & {
    __typename?: "ScriptureReference";
    firstVerses?: Maybe<Array<Maybe<BibleItem>>>;
    id: Scalars["ID"]["output"];
    relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
    relatedItemType?: Maybe<Scalars["String"]["output"]>;
    scripture: Scalars["String"]["output"];
    timelineSeconds?: Maybe<Scalars["Int"]["output"]>;
  };

/** A paginated list of search results */
export type SearchConnection = {
  __typename?: "SearchConnection";
  edges: Array<SearchEdge>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A single result in a paginated list of search results */
export type SearchEdge = {
  __typename?: "SearchEdge";
  cursor: Scalars["String"]["output"];
  node: SearchResult;
};

/** A content item returned by a search query */
export type SearchResult =
  | Article
  | BlogPost
  | Class
  | Experimental_Guide
  | Experimental_HelpCenterPage
  | Experimental_StaticPage
  | PodcastEpisode
  | PodcastSeries
  | Session
  | Video
  | VideoCategory
  | VideoCollection;

/** A single section's related item that is an actual Related Item */
export type SectionRelatedItems = {
  __typename?: "SectionRelatedItems";
  items?: Maybe<Array<RelatedItem>>;
  /** The ID of a section component inside the content body */
  sectionId: Scalars["String"]["output"];
};

/** An interface for forming time-specific segments of a parent entity */
export type Segment = {
  __typename?: "Segment";
  content?: Maybe<Scalars["String"]["output"]>;
  durationSeconds?: Maybe<Scalars["Float"]["output"]>;
  images?: Maybe<ImageSet>;
  /** A label to be displayed for the segment, most often the speaker */
  label?: Maybe<Scalars["String"]["output"]>;
  startTimestamp?: Maybe<Scalars["Float"]["output"]>;
  tag?: Maybe<Scalars["String"]["output"]>;
};

/** An ordered sequence of content items */
export type Sequence = {
  __typename?: "Sequence";
  callToAction?: Maybe<Scalars["String"]["output"]>;
  completionText?: Maybe<Scalars["String"]["output"]>;
  description: Scalars["Markdown"]["output"];
  id: Scalars["ID"]["output"];
  items?: Maybe<Array<Maybe<SequenceItem>>>;
  level?: Maybe<Scalars["Int"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

/** A content item in an ordered sequence */
export type SequenceItem =
  | BlogPost
  | MovementReading
  | PodcastEpisode
  | Quiz
  | Resource
  | Video;

/** Information relevant to an item's position in a sequence */
export type SequenceItemInfo = {
  __typename?: "SequenceItemInfo";
  description?: Maybe<Scalars["String"]["output"]>;
  label?: Maybe<Scalars["String"]["output"]>;
  subtitle?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ServiceMetadata = {
  __typename?: "ServiceMetadata";
  /** The version of Zed's core libraries running in this subgraph */
  coreVersion: Scalars["String"]["output"];
  hash: Scalars["String"]["output"];
  stackName: Scalars["String"]["output"];
  /** The subgraph-specific version */
  subgraphVersion?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated coreVersion now refers to the overall Zed version, while subgraphVersion is an optional subgraph-specific version */
  version: Scalars["String"]["output"];
};

/** A Classroom Session */
export type Session = ClassroomNode &
  Content & {
    __typename?: "Session";
    activity: IndividualContentActivity;
    admin_user?: Maybe<Admin_SessionUserData>;
    captionsUrl?: Maybe<Scalars["String"]["output"]>;
    class?: Maybe<Class>;
    /** @deprecated Field is no longer supported. Use class.id instead. */
    classId: Scalars["String"]["output"];
    /** @deprecated Field is no longer supported. Use class.slug instead. */
    classSlug: Scalars["String"]["output"];
    contentType: ContentType;
    /** @deprecated Field is no longer supported. Will be removed without replacement. */
    createdAt: Scalars["String"]["output"];
    description?: Maybe<Scalars["Markdown"]["output"]>;
    duration: Scalars["Int"]["output"];
    id: Scalars["ID"]["output"];
    /** @deprecated Field is no longer supported. Use id instead. */
    legacyId?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Field is no longer supported. Will be removed without replacement. */
    literaryDesignIds?: Maybe<Array<Scalars["String"]["output"]>>;
    /** @deprecated Field is no longer supported. Will be removed without replacement. */
    literaryDesigns?: Maybe<Array<LiteraryDesign>>;
    media?: Maybe<SessionMediaConnection>;
    module?: Maybe<Module>;
    /** @deprecated Field is no longer supported. Use module.id instead. */
    moduleId: Scalars["String"]["output"];
    /** @deprecated Field is no longer supported. Use module.position instead. */
    modulePosition: Scalars["Int"]["output"];
    position: Scalars["Int"]["output"];
    reflections?: Maybe<Array<Reflection>>;
    relatedItemType?: Maybe<Scalars["String"]["output"]>;
    seo: Seo;
    slides?: Maybe<Array<Slide>>;
    /** @deprecated Field is no longer supported. Use takewaysHtml instead. */
    takeways?: Maybe<Scalars["String"]["output"]>;
    takewaysHtml?: Maybe<Scalars["HTML"]["output"]>;
    teacherNotes?: Maybe<TeacherNotes>;
    title: Scalars["String"]["output"];
    /** @deprecated Field is no longer supported. Will be removed without replacement. */
    updatedAt: Scalars["String"]["output"];
    user?: Maybe<SessionUserData>;
  };

/** A Classroom Session */
export type SessionAdmin_UserArgs = {
  guid: Scalars["String"]["input"];
};

/** A Classroom Session */
export type SessionMediaArgs = {
  mediaType?: InputMaybe<MediaType>;
};

export type SessionMediaConnection = {
  __typename?: "SessionMediaConnection";
  edges: Array<SessionMediaEdge>;
  nodes?: Maybe<Array<Media>>;
  pageInfo: PageInfo;
};

export type SessionMediaEdge = {
  __typename?: "SessionMediaEdge";
  cursor: Scalars["String"]["output"];
  node?: Maybe<Media>;
};

export type SessionProgressInput = {
  sessionId: Scalars["ID"]["input"];
  timestamp: Scalars["Int"]["input"];
};

export type SessionUserData = ContentUserData & {
  __typename?: "SessionUserData";
  completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  currentTimestamp: Scalars["Int"]["output"];
  /** @deprecated Field is no longer supported. Send events from the client instead. */
  didJustComplete: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  isBookmarked: Scalars["Boolean"]["output"];
  isComplete: Scalars["Boolean"]["output"];
  notes?: Maybe<SessionUserNoteConnection>;
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  playedAt?: Maybe<Scalars["DateTime"]["output"]>;
  progress?: Maybe<Scalars["Float"]["output"]>;
  remainingDuration?: Maybe<Scalars["Int"]["output"]>;
};

export type SessionUserNoteConnection = {
  __typename?: "SessionUserNoteConnection";
  /** The number of notes the logged in user has written for this session */
  totalCount: Scalars["Int"]["output"];
};

/** Data needed to set the status of a NewsletterPreference */
export type SetNewsletterPreferenceInput = {
  newsletterType: NewsletterType;
  status: NewsletterPreferenceStatus;
};

/** Indicates the method by which a user signed in */
export enum SignInProvider {
  Apple = "apple",
  Email = "email",
  Google = "google",
  Other = "other",
}

/** The most discreet, concrete form of an Essay */
export type SimpleEssay = Essay & {
  __typename?: "SimpleEssay";
  content: Scalars["Unist"]["output"];
  createdAt: Scalars["String"]["output"];
  description: Scalars["Markdown"]["output"];
  id: Scalars["ID"]["output"];
  images: ImageSet;
  meta: PageMeta;
  octoberId?: Maybe<Scalars["Int"]["output"]>;
  publishedAt: Scalars["String"]["output"];
  relatedItems: Array<RelatedItem>;
  resourceLinks: Array<ResourceLink>;
  slug: Scalars["String"]["output"];
  subTitle?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
};

export type SingleChoiceQuestion = ClassroomNode &
  QuizQuestionCommon & {
    __typename?: "SingleChoiceQuestion";
    answer: Array<Scalars["String"]["output"]>;
    description: Scalars["String"]["output"];
    errorMessage: QuizQuestionFeedbackMessage;
    id: Scalars["ID"]["output"];
    /** @deprecated Field is no longer supported. Use id instead. */
    legacyId?: Maybe<Scalars["String"]["output"]>;
    options?: Maybe<Array<QuizQuestionOption>>;
    successMessage: QuizQuestionFeedbackMessage;
    title: Scalars["String"]["output"];
    type: QuizQuestionType;
    user?: Maybe<QuizQuestionUserData>;
  };

/** A group of studies that build a particular skill */
export type Skill = {
  __typename?: "Skill";
  id: Scalars["ID"]["output"];
  label?: Maybe<Scalars["String"]["output"]>;
  studyGroups?: Maybe<Array<Maybe<StudyGroup>>>;
  title?: Maybe<Scalars["String"]["output"]>;
};

/** A paginated list of skills */
export type SkillsConnection = {
  __typename?: "SkillsConnection";
  edges: Array<SkillsEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A single skill in a paginated list */
export type SkillsEdge = {
  __typename?: "SkillsEdge";
  cursor: Scalars["String"]["output"];
  node: Skill;
};

export type Slide = ClassroomNode & {
  __typename?: "Slide";
  config?: Maybe<Scalars["String"]["output"]>;
  duration?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  position: Scalars["Int"]["output"];
  timestamp: Scalars["Int"]["output"];
};

/** Sort direction */
export enum SortEnum {
  Asc = "ASC",
  Desc = "DESC",
}

/** Information about a payment intent for the Stripe payment processor */
export type StripePayment = {
  __typename?: "StripePayment";
  clientSecret: Scalars["String"]["output"];
  customerId: Scalars["String"]["output"];
  /** can be utilized by the stripe web sdk to enrich the payment flow with customer information, only available when logged in */
  customerSessionSecret?: Maybe<Scalars["String"]["output"]>;
  /** can be utilized by the stripe native sdk to enrich the payment flow with customer information, only available when logged in */
  ephemeralKey?: Maybe<Scalars["String"]["output"]>;
  frequency: DonationFrequency;
  /** token used submit v2 post giving information will be null for legacy payments */
  postGivingToken?: Maybe<Scalars["String"]["output"]>;
  publishableKey: Scalars["String"]["output"];
  shouldCollectAddress?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Arbitrary text content with formatting information */
export type StructuredContent = TimelineEventData & {
  __typename?: "StructuredContent";
  items?: Maybe<Array<Maybe<StructuredContentItem>>>;
  relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  timelineSeconds?: Maybe<Scalars["Int"]["output"]>;
};

/** An individual text item */
export type StructuredContentItem = {
  __typename?: "StructuredContentItem";
  /** If type == 'text', this can be formatted with Markdown, otherwise it is plaintext */
  content?: Maybe<Scalars["String"]["output"]>;
  /** title, subtitle, or text */
  type?: Maybe<Scalars["String"]["output"]>;
};

/** A study with activities and optional reading */
export type Study = {
  __typename?: "Study";
  activities?: Maybe<Array<Maybe<Sequence>>>;
  available?: Maybe<Scalars["Boolean"]["output"]>;
  colorPrimary?: Maybe<Scalars["String"]["output"]>;
  colorSecondary?: Maybe<Scalars["String"]["output"]>;
  description: Scalars["Markdown"]["output"];
  firstMovementReading?: Maybe<MovementReading>;
  id: Scalars["ID"]["output"];
  images: ImageSet;
  label?: Maybe<Scalars["String"]["output"]>;
  linkGroups?: Maybe<Array<Maybe<StudyLinkGroup>>>;
  movementReadings?: Maybe<Array<Maybe<MovementReading>>>;
  publishDate?: Maybe<Scalars["Date"]["output"]>;
  relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  skill?: Maybe<Skill>;
  subtitle?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  /** movement | standard */
  type?: Maybe<Scalars["String"]["output"]>;
};

/** A group of related studies */
export type StudyGroup = {
  __typename?: "StudyGroup";
  available: Scalars["Boolean"]["output"];
  description: Scalars["Markdown"]["output"];
  id: Scalars["ID"]["output"];
  publishDate?: Maybe<Scalars["Date"]["output"]>;
  studies: Array<Study>;
  subtitle?: Maybe<Scalars["String"]["output"]>;
  tip?: Maybe<Tip>;
  title: Scalars["String"]["output"];
};

/** Information about a standalone study lesson */
export type StudyLesson = Node &
  TimelineEventData & {
    __typename?: "StudyLesson";
    description: Scalars["Markdown"]["output"];
    id: Scalars["ID"]["output"];
    images: ImageSet;
    relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
    relatedItemType?: Maybe<Scalars["String"]["output"]>;
    timelineSeconds?: Maybe<Scalars["Int"]["output"]>;
    title: Scalars["String"]["output"];
    /** reflections or studylesson */
    type?: Maybe<Scalars["String"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
  };

/** Information about a link to a Study */
export type StudyLink = {
  __typename?: "StudyLink";
  description: Scalars["Markdown"]["output"];
  firstMovementReading?: Maybe<MovementReading>;
  firstMovementStudy?: Maybe<Study>;
  id: Scalars["ID"]["output"];
  images: ImageSet;
  scriptureReferences: Array<Maybe<Scalars["String"]["output"]>>;
  study?: Maybe<Study>;
  studyId: Scalars["Int"]["output"];
  title: Scalars["String"]["output"];
};

/** A named group of links to a study */
export type StudyLinkGroup = {
  __typename?: "StudyLinkGroup";
  links?: Maybe<Array<Maybe<StudyLink>>>;
  title: Scalars["String"]["output"];
};

/** A single study note */
export type StudyNote = {
  __typename?: "StudyNote";
  createdAt?: Maybe<Scalars["String"]["output"]>;
  description: Scalars["Markdown"]["output"];
  filePath: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  image?: Maybe<ImageSet>;
  lang: Scalars["String"]["output"];
  publishedAt: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["String"]["output"]>;
};

/** A notable word used in scripture */
export type StudyWord = Node &
  TimelineEventData & {
    __typename?: "StudyWord";
    audioUrl?: Maybe<Scalars["String"]["output"]>;
    color?: Maybe<Scalars["String"]["output"]>;
    definition?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    images: ImageSet;
    keyPassages?: Maybe<Array<Maybe<ScriptureReference>>>;
    phoneticSpelling?: Maybe<Scalars["String"]["output"]>;
    relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
    relatedItemType?: Maybe<Scalars["String"]["output"]>;
    synonyms?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    tenses?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
    textEnglish?: Maybe<Scalars["String"]["output"]>;
    textOriginal?: Maybe<Scalars["String"]["output"]>;
    timelineSeconds?: Maybe<Scalars["Int"]["output"]>;
  };

/** The available sort properties for Videos */
export enum StudyWordSortField {
  TextEnglish = "TEXT_ENGLISH",
}

/** An instance of a study word sort input, providing a field and direction. */
export type StudyWordSortInput = {
  direction: SortEnum;
  field: StudyWordSortField;
};

/** A paginated list of study words */
export type StudyWordsConnection = {
  __typename?: "StudyWordsConnection";
  edges: Array<StudyWordsEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** An individual study word in a paginated list */
export type StudyWordsEdge = {
  __typename?: "StudyWordsEdge";
  cursor: Scalars["String"]["output"];
  node: StudyWord;
};

/** A subject under which a content item can be categorized" */
export type Subject = {
  __typename?: "Subject";
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
};

/** Fields for a survey about a piece of BibleProject content */
export type SubmitContentSurveyInput = {
  additionalThoughts?: InputMaybe<Scalars["String"]["input"]>;
  contentId: Scalars["String"]["input"];
  contentTitle?: InputMaybe<Scalars["String"]["input"]>;
  contentType?: InputMaybe<Scalars["String"]["input"]>;
  /** Information about the platform/OS the form was submitted from */
  platformInfo?: InputMaybe<Scalars["String"]["input"]>;
  /** Text description of the rating value, as presented to the submitter */
  ratingText?: InputMaybe<Scalars["String"]["input"]>;
  /** The numeric value of the rating */
  ratingValue?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Data needed to subscribe an email address to one or more newsletters */
export type SubscribeToNewslettersInput = {
  email: Scalars["String"]["input"];
  givenName?: InputMaybe<Scalars["String"]["input"]>;
  newsletterTypes: Array<NewsletterType>;
  surname?: InputMaybe<Scalars["String"]["input"]>;
};

/** The frequency of charges for a recurring payment */
export enum SubscriptionFrequency {
  Annual = "annual",
  Monthly = "monthly",
}

/** Information to initialize a subscription */
export type SubscriptionInput = {
  amount: Scalars["Int"]["input"];
  campaignCode?: InputMaybe<GivingCampaignCode>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  frequency: SubscriptionFrequency;
  givenName?: InputMaybe<Scalars["String"]["input"]>;
  /** The device/browser language of the patron */
  languageLocale?: InputMaybe<Scalars["LanguageCode"]["input"]>;
  /** The language of the site or app that the patron is giving from */
  languageSource: Scalars["LanguageCode"]["input"];
  leadSource?: InputMaybe<Scalars["String"]["input"]>;
  /** Defaults to false - set to true if you are providing a perk selection experience */
  perkSelectionEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  surname?: InputMaybe<Scalars["String"]["input"]>;
};

/** A payment method that can be used for subscriptions */
export type SubscriptionPaymentMethod = {
  id: Scalars["ID"]["output"];
};

/** The status of a subscription */
export enum SubscriptionStatus {
  Active = "active",
  Canceled = "canceled",
  Incomplete = "incomplete",
  IncompleteExpired = "incompleteExpired",
  PastDue = "pastDue",
  Trialing = "trialing",
  Unpaid = "unpaid",
}

export type TableVisualData = VisualDataCommon & {
  __typename?: "TableVisualData";
  body: Scalars["String"]["output"];
  minWidth?: Maybe<Scalars["String"]["output"]>;
  slideWidth?: Maybe<Scalars["String"]["output"]>;
  type: VisualType;
};

export type Tag = ClassroomNode & {
  __typename?: "Tag";
  content: Scalars["String"]["output"];
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  id: Scalars["ID"]["output"];
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  legacyId?: Maybe<Scalars["String"]["output"]>;
};

export type Teacher = ClassroomNode & {
  __typename?: "Teacher";
  bio?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  classes?: Maybe<Array<Class>>;
  id: Scalars["ID"]["output"];
  image?: Maybe<ClassroomImage>;
  /** @deprecated Field is no longer supported. Use id instead. */
  legacyId?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
};

export type TeacherNotes = ClassroomNode & {
  __typename?: "TeacherNotes";
  content: Scalars["String"]["output"];
  contentHtml: Scalars["HTML"]["output"];
  id: Scalars["ID"]["output"];
  /** @deprecated Field is no longer supported. Use id instead. */
  legacyId?: Maybe<Scalars["String"]["output"]>;
  session: Session;
};

export type Testimonial = ClassroomNode & {
  __typename?: "Testimonial";
  author: Scalars["String"]["output"];
  content: Scalars["String"]["output"];
  /** @deprecated Field is no longer supported. Will be removed without replacement. */
  contentHtml: Scalars["HTML"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  /** @deprecated Field is no longer supported. Use id instead. */
  legacyId?: Maybe<Scalars["String"]["output"]>;
};

/** An arbitrary item associated with a timestamp in a video or audio file */
export type TimelineEvent =
  | BlogPost
  | BookReference
  | ChapterHeading
  | Course
  | Image
  | Insight
  | Person
  | PodcastEpisode
  | PodcastSeries
  | Quote
  | ScriptureReference
  | StructuredContent
  | StudyLesson
  | StudyWord
  | Video
  | VideoCategory
  | WebReference;

/** Information needed to understand a timeline event's position and type */
export type TimelineEventData = {
  relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  timelineSeconds?: Maybe<Scalars["Int"]["output"]>;
};

/** An informational tip to show to users */
export type Tip = {
  __typename?: "Tip";
  callToAction?: Maybe<Scalars["String"]["output"]>;
  description: Scalars["String"]["output"];
  dismissable: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  text?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type TrueFalseQuestion = ClassroomNode &
  QuizQuestionCommon & {
    __typename?: "TrueFalseQuestion";
    answer: Array<Scalars["String"]["output"]>;
    description: Scalars["String"]["output"];
    errorMessage: QuizQuestionFeedbackMessage;
    id: Scalars["ID"]["output"];
    /** @deprecated Field is no longer supported. Use id instead. */
    legacyId?: Maybe<Scalars["String"]["output"]>;
    options?: Maybe<Array<QuizQuestionOption>>;
    successMessage: QuizQuestionFeedbackMessage;
    title: Scalars["String"]["output"];
    type: QuizQuestionType;
    user?: Maybe<QuizQuestionUserData>;
  };

export type UnstableSlides = {
  __typename?: "UnstableSlides";
  data?: Maybe<Scalars["String"]["output"]>;
};

/** Data needed to update a user's completion status on a specific content item */
export type UpdateContentCompletionStatusInput = {
  /** the content's GUID */
  contentId: Scalars["ID"]["input"];
  /** The type of content this completion status update is for */
  contentType: ContentProgressContentType;
  /** The completion status of the content */
  value: Scalars["Boolean"]["input"];
};

/** Response from updateContentProgress */
export type UpdateContentCompletionStatusResponse = {
  __typename?: "UpdateContentCompletionStatusResponse";
  /** When this progress event was recorded. */
  updatedAt: Scalars["Date"]["output"];
};

/** Input for the updateContentProgress mutation. */
export type UpdateContentProgressInput = {
  /** the content's GUID */
  contentId: Scalars["ID"]["input"];
  /** The type of content this progress update is for */
  contentType: ContentProgressContentType;
  /** Metadata describing the client environment */
  metadata: ContentProgressMetadataInput;
  /**
   * Progress point value (meaning depends on client implementation, but should be consistent per content type).
   * Examples:
   * - video/audio content - current timestamp in seconds the user has watched/listened to
   * - written content - percentage of content read/viewed
   */
  value: Scalars["Int"]["input"];
};

/** Response from updateContentProgress */
export type UpdateContentProgressResponse = {
  __typename?: "UpdateContentProgressResponse";
  /** When this progress event was recorded. */
  updatedAt: Scalars["Date"]["output"];
};

/** Input for updating a donation with comments */
export type UpdateDonationWithCommentInput = {
  donationComment?: InputMaybe<DonationCommentInput>;
  donationId: Scalars["ID"]["input"];
  feedbackComment?: InputMaybe<Scalars["String"]["input"]>;
};

/** Input for the `updateEmail` mutation */
export type UpdateEmailInput = {
  email: Scalars["String"]["input"];
};

/** Response to a request to update a user's email address */
export type UpdateEmailResponse = {
  __typename?: "UpdateEmailResponse";
  authorization?: Maybe<Authorization>;
  user?: Maybe<User>;
};

/** Input for the `updatePasswordFromResetToken` mutation */
export type UpdatePasswordFromResetTokenInput = {
  newPassword: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
};

/** Input for the `updatePassword` mutation */
export type UpdatePasswordInput = {
  currentPassword: Scalars["String"]["input"];
  newPassword: Scalars["String"]["input"];
};

/** Response to a request for a reset password email */
export type UpdatePasswordResponse = {
  __typename?: "UpdatePasswordResponse";
  success: Scalars["Boolean"]["output"];
};

/** Input for selecting a perk and/or updating a user's profile */
export type UpdatePerkSelectionProfileInput = {
  milestoneSelection?: InputMaybe<MilestoneSelectionInput>;
  postGivingToken: Scalars["String"]["input"];
  profileUpdates?: InputMaybe<PerkProfileInput>;
};

/** Information to update a subscription */
export type UpdateSubscriptionInput = {
  amount: Scalars["Int"]["input"];
  billingAnchor?: InputMaybe<BillingDateAnchorUpdateInput>;
  frequency: SubscriptionFrequency;
  subscriptionId: Scalars["ID"]["input"];
};

/** Distinct BibleProject user. */
export type User = {
  __typename?: "User";
  /** The user's ID in the authentication provider's system */
  authenticationProviderId?: Maybe<Scalars["String"]["output"]>;
  classroomNotesAndReflections: Array<UserDownloadLink>;
  donationHistory: DonationConnection;
  email?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use `publicUserId` and/or `email`. */
  id?: Maybe<Scalars["String"]["output"]>;
  newsletterPreferences: Array<NewsletterPreference>;
  primarySubscription?: Maybe<DonationSubscription>;
  profile?: Maybe<Profile>;
  /**
   * The user's publicId. If the publicId is null, will return the value of publicUserId
   * @deprecated Use `publicUserId`.
   */
  publicId?: Maybe<Scalars["String"]["output"]>;
  /** For use in public tracking */
  publicUserId?: Maybe<Scalars["String"]["output"]>;
  signInProvider?: Maybe<SignInProvider>;
  /** List of a users payment methods that can be used for subscriptions */
  subscriptionPaymentMethods: Array<SubscriptionPaymentMethod>;
  subscriptions: Array<DonationSubscription>;
  totalDonationAmount: Scalars["Int"]["output"];
  /**
   * Get a year end statement for a given year for the currently logged-in user.
   *
   * The result may be `null`, which indicates that the user has no
   * contributions for the given year.
   */
  yearEndStatement?: Maybe<YearEndStatement>;
  /** Get all year end statements for the currently logged-in user */
  yearEndStatements: Array<YearEndStatement>;
};

/** Distinct BibleProject user. */
export type UserDonationHistoryArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<DonationHistoryFilters>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<DonationHistorySort>>;
};

/** Distinct BibleProject user. */
export type UserYearEndStatementArgs = {
  year: Scalars["Int"]["input"];
};

/**
 * A single user audio entry
 * User Audio is a user-submitted audio file and its meta.
 */
export type UserAudio = {
  __typename?: "UserAudio";
  audioUrl: Scalars["String"]["output"];
  author: Scalars["String"]["output"];
  createdAt: Scalars["String"]["output"];
  durationSeconds: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  publishedAt: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
};

/** The available sort properties for User Audios */
export enum UserAudioSortField {
  PublishedAt = "PUBLISHED_AT",
}

/** An instance of a user audio sort input, providing a field and direction. */
export type UserAudioSortInput = {
  direction: SortEnum;
  field: UserAudioSortField;
};

/** A page of userAudios with edges and pageInfo */
export type UserAudiosConnection = {
  __typename?: "UserAudiosConnection";
  edges: Array<UserAudiosEdge>;
  pageInfo: PageInfo;
};

/** An edge with a UserAudio node from a connection */
export type UserAudiosEdge = {
  __typename?: "UserAudiosEdge";
  cursor: Scalars["String"]["output"];
  node: UserAudio;
};

export type UserDownloadLink = {
  __typename?: "UserDownloadLink";
  mimeType: Scalars["String"]["output"];
  url: Scalars["URL"]["output"];
};

/** A range between two ChapterVerses */
export type VerseRange = {
  __typename?: "VerseRange";
  book?: Maybe<Scalars["String"]["output"]>;
  ending?: Maybe<ChapterVerse>;
  includedVerses?: Maybe<Array<Scalars["String"]["output"]>>;
  starting?: Maybe<ChapterVerse>;
};

/** A single BibleProject video */
export type Video = CoreLanguageContent &
  Node &
  TimelineEventData & {
    __typename?: "Video";
    activity: IndividualContentActivity;
    alternateLanguages: AlternateLanguagesConnection;
    /** @deprecated Adding multiple aspect ratios in playbackSources. */
    aspectRatio?: Maybe<Scalars["Float"]["output"]>;
    /** @deprecated VideoCategory is replaced by VideoCollection. */
    category?: Maybe<VideoCategory>;
    collections?: Maybe<VideoVideoCollectionConnection>;
    color?: Maybe<Scalars["String"]["output"]>;
    contentId: Scalars["String"]["output"];
    description: Scalars["Markdown"]["output"];
    descriptionMarkdown?: Maybe<Scalars["Markdown"]["output"]>;
    discussionText?: Maybe<Scalars["String"]["output"]>;
    durationSeconds?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Moved into collections. */
    episodeNumber?: Maybe<Scalars["Int"]["output"]>;
    experimental_discussionQuestions: Array<Scalars["String"]["output"]>;
    id: Scalars["ID"]["output"];
    /** Different sized images for an item */
    images: ImageSet;
    isPreview: Scalars["Boolean"]["output"];
    language: ContentLanguage;
    meta: PageMeta;
    /** @deprecated Moved into playbackSources. */
    paths?: Maybe<VideoFiles>;
    playbackSources?: Maybe<VideoAspects>;
    publishDate?: Maybe<Scalars["Date"]["output"]>;
    /** @deprecated Use relatedItems. */
    relatedItemGroups?: Maybe<RelatedItemGroupsNamed>;
    relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
    relatedItemType?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Use relationships for fully featured connections. */
    relatedItems?: Maybe<Array<Maybe<RelatedItem>>>;
    relationships: RelationshipConnection;
    scriptureReferences?: Maybe<Array<Maybe<ScriptureReference>>>;
    sequenceItemInfo?: Maybe<SequenceItemInfo>;
    shareUrl?: Maybe<Scalars["String"]["output"]>;
    slug: Scalars["String"]["output"];
    subtitle?: Maybe<Scalars["String"]["output"]>;
    timelineEvents?: Maybe<Array<Maybe<TimelineEvent>>>;
    timelineSeconds?: Maybe<Scalars["Int"]["output"]>;
    title: Scalars["String"]["output"];
    transcript?: Maybe<Scalars["Unist"]["output"]>;
    /** @deprecated Moved into playbackSources. */
    youtubeId?: Maybe<Scalars["String"]["output"]>;
  };

/** A single BibleProject video */
export type VideoAlternateLanguagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A single BibleProject video */
export type VideoCollectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A single BibleProject video */
export type VideoRelationshipsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
  predicates?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

/** An single video aspect's available playback IDs */
export type VideoAspectPlaybackIds = {
  __typename?: "VideoAspectPlaybackIds";
  m3u8?: Maybe<Scalars["String"]["output"]>;
  mp4?: Maybe<Scalars["String"]["output"]>;
  mux?: Maybe<Scalars["String"]["output"]>;
  youtube?: Maybe<Scalars["String"]["output"]>;
};

/** Available aspects on a video */
export type VideoAspects = {
  __typename?: "VideoAspects";
  landscape?: Maybe<VideoAspectPlaybackIds>;
  portrait?: Maybe<VideoAspectPlaybackIds>;
};

/** A paginated list of video categories */
export type VideoCategoriesConnection = {
  __typename?: "VideoCategoriesConnection";
  edges: Array<VideoCategoryEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A named category containing videos and optionally other categories */
export type VideoCategory = Node &
  TimelineEventData & {
    __typename?: "VideoCategory";
    /** Videos and Categories that are direct children of this category */
    children?: Maybe<Array<Maybe<VideoCategoryChild>>>;
    /** The primary color associated with the category in hexadecimal format */
    color?: Maybe<Scalars["String"]["output"]>;
    /** @deprecated Temporarily needed for child item resolution */
    contentId?: Maybe<Scalars["String"]["output"]>;
    description: Scalars["Markdown"]["output"];
    id: Scalars["ID"]["output"];
    images: ImageSet;
    isSeries?: Maybe<Scalars["Boolean"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
    latestVideoDate?: Maybe<Scalars["Date"]["output"]>;
    /** The number of videos in the category */
    numVideos?: Maybe<Scalars["Int"]["output"]>;
    numVideosExpected?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Legacy October ID associated with the category; use only for
     * maintaining backwards compatibility with existing integrations
     */
    octoberId?: Maybe<Scalars["Int"]["output"]>;
    /** @deprecated Use relatedItems. */
    relatedItemGroups?: Maybe<RelatedItemGroupsNamed>;
    relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
    relatedItemType?: Maybe<Scalars["String"]["output"]>;
    relatedItems?: Maybe<Array<Maybe<RelatedItem>>>;
    /** Public URL for the category */
    shareUrl?: Maybe<Scalars["String"]["output"]>;
    /** Subjects associated with this video category */
    subjects?: Maybe<Array<Maybe<Subject>>>;
    timelineSeconds?: Maybe<Scalars["Int"]["output"]>;
    title: Scalars["String"]["output"];
    trailer?: Maybe<VideoFiles>;
    type?: Maybe<Scalars["String"]["output"]>;
    /** Videos associated with this video category */
    videos?: Maybe<Array<Maybe<Video>>>;
  };

/** Items that can be owned by a Video Category */
export type VideoCategoryChild = Video | VideoCategory;

/** A single video category within a paginated list */
export type VideoCategoryEdge = {
  __typename?: "VideoCategoryEdge";
  cursor: Scalars["String"]["output"];
  node: VideoCategory;
};

/** A short section of a longer video */
export type VideoClip = {
  __typename?: "VideoClip";
  endSeconds?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  images: ImageSet;
  relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  startSeconds?: Maybe<Scalars["Int"]["output"]>;
  subtitle?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  video?: Maybe<Video>;
};

/** A named collection containing videos */
export type VideoCollection = CoreLanguageContent & {
  __typename?: "VideoCollection";
  alternateLanguages: AlternateLanguagesConnection;
  collectionType: VideoCollectionTypeEnum;
  createdAt?: Maybe<Scalars["String"]["output"]>;
  description: Scalars["Markdown"]["output"];
  id: Scalars["ID"]["output"];
  images: ImageSet;
  language: ContentLanguage;
  meta: PageMeta;
  numVideosExpected?: Maybe<Scalars["Int"]["output"]>;
  publishedAt: Scalars["String"]["output"];
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  shareUrl?: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["String"]["output"]>;
  videos?: Maybe<VideoCollectionVideoConnection>;
};

/** A named collection containing videos */
export type VideoCollectionAlternateLanguagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A named collection containing videos */
export type VideoCollectionVideosArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The different types of video collections */
export enum VideoCollectionTypeEnum {
  Bundle = "BUNDLE",
  Series = "SERIES",
}

/** A connection between video and video collection */
export type VideoCollectionVideoConnection = {
  __typename?: "VideoCollectionVideoConnection";
  edges: Array<VideoCollectionVideoEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** A video collection edge on a video */
export type VideoCollectionVideoEdge = {
  __typename?: "VideoCollectionVideoEdge";
  cursor: Scalars["String"]["output"];
  episodeNumber?: Maybe<Scalars["Int"]["output"]>;
  node: Video;
};

/** A single video in a pagintated list */
export type VideoEdge = {
  __typename?: "VideoEdge";
  cursor: Scalars["String"]["output"];
  node: Video;
};

/** A single video in various formats */
export type VideoFiles = {
  __typename?: "VideoFiles";
  /** The public URL for streaming video */
  m3u8?: Maybe<Scalars["String"]["output"]>;
  /** The public URL for a downloadable video */
  mp4?: Maybe<Scalars["String"]["output"]>;
};

/** The available sort properties for Videos */
export enum VideoSortField {
  PublishedAt = "PUBLISHED_AT",
  Title = "TITLE",
}

/**
 * An instance of a video sort input, providing a field and direction.
 * Multiple can be provided, for multi dimensional sort.
 *
 * Each VideoSortInput is processed in order provided. If you sort
 * by field: TITLE, and then field PUBLISHED_AT, sort will first
 * apply to title, and then to published at, following standard
 * SQL rules.
 */
export type VideoSortInput = {
  direction: SortEnum;
  field: VideoSortField;
};

/** A connection between video and video collection */
export type VideoVideoCollectionConnection = {
  __typename?: "VideoVideoCollectionConnection";
  edges: Array<VideoVideoCollectionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars["Int"]["output"];
};

/** A video collection edge on a video */
export type VideoVideoCollectionEdge = {
  __typename?: "VideoVideoCollectionEdge";
  cursor: Scalars["String"]["output"];
  episodeNumber?: Maybe<Scalars["Int"]["output"]>;
  node: VideoCollection;
};

export type VideoVisualData = VisualDataCommon & {
  __typename?: "VideoVisualData";
  alt?: Maybe<Scalars["String"]["output"]>;
  externalId?: Maybe<Scalars["String"]["output"]>;
  src: Scalars["URL"]["output"];
  title: Scalars["String"]["output"];
  type: VisualType;
};

/** A paginated list of videos */
export type VideosConnection = {
  __typename?: "VideosConnection";
  edges: Array<VideosEdge>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

/** A single video in a paginated list */
export type VideosEdge = {
  __typename?: "VideosEdge";
  cursor: Scalars["String"]["output"];
  node: Video;
};

export type Visual = {
  __typename?: "Visual";
  data?: Maybe<VisualData>;
  id: Scalars["ID"]["output"];
};

export type VisualData =
  | DiagramVisualData
  | IllustrationVisualData
  | ImageVisualData
  | LiteraryDesign
  | MacroLiteraryDesign
  | TableVisualData
  | VideoVisualData;

export type VisualDataCommon = {
  type: VisualType;
};

export enum VisualType {
  Diagram = "DIAGRAM",
  Illustration = "ILLUSTRATION",
  Image = "IMAGE",
  LiteraryDesign = "LITERARY_DESIGN",
  MacroLiteraryDesign = "MACRO_LITERARY_DESIGN",
  Table = "TABLE",
  Video = "VIDEO",
}

/** Information about an HTML url */
export type WebReference = TimelineEventData & {
  __typename?: "WebReference";
  label?: Maybe<Scalars["String"]["output"]>;
  relatedItemLabel?: Maybe<Scalars["String"]["output"]>;
  relatedItemType?: Maybe<Scalars["String"]["output"]>;
  subtitle?: Maybe<Scalars["String"]["output"]>;
  timelineSeconds?: Maybe<Scalars["Int"]["output"]>;
  title: Scalars["String"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
};

/** Summary statement of a patron's contributions for a given year */
export type YearEndStatement = {
  __typename?: "YearEndStatement";
  /** Base64-encoded binary data of the PDF file for the printed year-end statement */
  pdfBlob?: Maybe<Scalars["String"]["output"]>;
  /** Total of all contributions for the year in smallest denomination (e.g. cents for USD). */
  totalAmount: Scalars["Int"]["output"];
  /** Statement year, e.g. 2024 */
  year: Scalars["Int"]["output"];
};
